import i18next from 'i18next';

// Vietnamese translations defined directly
const viTranslations = {
  "common": {
    "all": "Tất cả",
    "or": "Hoặc",
    "search": "Tìm kiếm",
    "loading": "Đang tải...",
    "actions": "Chọn",
    "create": "Tạo",
    "edit": "Chỉnh sửa",
    "delete": "Xóa",
    "deleting": "Đang xóa...",
    "save": "Lưu",
    "cancel": "Huỷ",
    "confirm": "Xác nhận",
    "add": "Thêm",
    "apply": "Áp dụng",
    "filter": "Lọc",
    "filters": "Bộ lọc",
    "reset": "Đặt lại",
    "refresh": "Làm mới",
    "clear": "Xóa chọn",
    "viewOptions": "Tùy chọn hiển thị",
    "columns": "Cột",
    "noResults": "Không tìm thấy kết quả",
    "previous": "Trước",
    "next": "Tiếp",
    "noData": "Không có dữ liệu",
    "required": "Bắt buộc nhập",
    "continue": "Tiếp tục",
    "from": "Từ",
    "to": "Đến",
    "searchPlaceholder": "Tìm kiếm...",
    "searchShortcut": "⌘K",
    "toggleTheme": "Chuyển đổi chủ đề",
    "light": "Sáng",
    "dark": "Tối",
    "system": "Hệ thống",
    "theme": "Chủ đề",
    "skipToMain": "Bỏ qua đến nội dung chính",
    "commandPlaceholder": "Nhập lệnh hoặc tìm kiếm...",
    "noResultsFound": "Không tìm thấy kết quả.",
    "comingSoon": "Sắp ra mắt 👀",
    "comingSoonDesc": "Trang này chưa được tạo. Hãy đợi nhé!",
    "showPassword": "Hiển thị mật khẩu",
    "hidePassword": "Ẩn mật khẩu",
    "personal": "Thông tin cá nhân",
    "documents": "Tài liệu",
    "download": "Tải xuống",
    "frontIdCard": "CCCD (Mặt trước)",
    "backIdCard": "CCCD (Mặt sau)",
    "profilePicture": "Ảnh chân dung",
    "clickToView": "Nhấp để xem",
    "openInNewTab": "Mở trong tab mới",
    "viewGuide": "Xem hướng dẫn",
    "uploadImage": "Tải lên hình ảnh",
    "removeImage": "Xóa hình ảnh",
    "noFile": "Chưa có tệp",
    "selected": "đã chọn",
    "selectAll": "Chọn tất cả",
    "selectRow": "Chọn hàng",
    "selectPlaceholder": "Chọn...",
    "rowsPerPage": "Hàng / trang",
    "page": "Trang",
    "of": "trên",
    "rowsSelected": "hàng đã chọn",
    "goToFirstPage": "Đến trang đầu",
    "goToPreviousPage": "Đến trang trước",
    "goToNextPage": "Đến trang tiếp",
    "goToLastPage": "Đến trang cuối",
    "import": "Nhập",
    "export": "Xuất file",
    "morePages": "Nhiều trang hơn",
    "asc": "Tăng",
    "desc": "Giảm",
    "hide": "Ẩn",
    "saving": "Đang lưu",
    "unknown": " - ",
    "optional": "Tùy chọn",
    "enterPlaceholder": "Nhập {{field}}...",
    "roles": "Vai trò",
    "view": "Xem",
    "close": "Đóng",
    "history": "Lịch sử",
    "showing": "Hiển thị {{start}}-{{end}} / {{total}}",
    "open": "Mở",
    "rename": "Đổi tên",
    "move": "Di chuyển",
    "confirmDelete": "Bạn có chắc chắn muốn xóa mục đã chọn?",
    "exportSuccess": "Xuất báo cáo thành công",
    "exportError": "Lỗi khi xuất báo cáo",
    "exportFailed": "Xuất báo cáo thất bại",
    "exportFailedDesc": "Vui lòng thử lại sau",
    "exporting": "Đang xuất file...",
    "searching": "Đang tìm kiếm...",
    "createdAt": "Ngày tạo",
    "createdBy": "Tạo bởi",
    "updatedAt": "Ngày cập nhật",
    "updatedBy": "Cập nhật bởi",
    "selectDate": "Chọn ngày",
    "status": "Trạng thái",
    "active": "Hoạt động",
    "inactive": "Không hoạt động",
    "activate": "Kích hoạt",
    "deactivate": "Vô hiệu hóa",
    "error": {
      "generic": "Đã xảy ra lỗi không xác định",
      "contentNotModified": "Nội dung không được thay đổi",
      "sessionExpired": "Phiên đăng nhập đã hết hạn",
      "internalServerError": "Lỗi máy chủ nội bộ",
      "somethingWentWrong": "Đã xảy ra lỗi"
    },
    "somethingWentWrong": "Đã xảy ra lỗi",
    "retry": "Thử lại",
    "update": "Cập nhật",
    "tag": "Thẻ",
    "tags": "Thẻ",
    "searchTag": "Tìm thẻ...",
    "searchTags": "Tìm kiếm thẻ...",
    "noTagsFound": "Không tìm thấy thẻ",
    "selectTags": "Chọn thẻ...",
  },
  "errors": {
    "unauthorized": {
      "title": "Không có quyền truy cập",
      "heading": "Bạn không có quyền truy cập",
      "message": "Bạn không có quyền truy cập vào trang này. Vui lòng liên hệ với quản trị viên nếu bạn nghĩ đây là lỗi.",
      "goBack": "Quay lại",
      "backToHome": "Về trang chủ"
    },
    "forbidden": {
      "title": "Bị cấm truy cập",
      "heading": "Truy cập bị từ chối",
      "message": "Bạn không được phép truy cập vào tài nguyên này. Vui lòng liên hệ với quản trị viên nếu bạn nghĩ đây là lỗi.",
      "goBack": "Quay lại",
      "backToHome": "Về trang chủ"
    },
    "locationRequired": {
      "title": "Yêu cầu chia sẻ vị trí",
      "heading": "Ứng dụng cần quyền truy cập vị trí để xác nhận quyền truy cập hợp lệ và đảm bảo an toàn hệ thống.",
      "message": "Vui lòng cấp quyền trong cài đặt trình duyệt sau đó thử lại.",
      "retry": "Thử lại",
      "goToSignIn": "Về trang đăng nhập",
      "browserGuide": "Hướng dẫn cấp quyền vị trí theo trình duyệt:",
      "chrome": "Chrome: Cài đặt → Quyền riêng tư và bảo mật → Cài đặt trang web → Vị trí",
      "firefox": "Firefox: Cài đặt → Quyền riêng tư và bảo mật → Quyền",
      "edge": "Edge: Cài đặt → Quyền riêng tư và bảo mật → Quyền trang web → Vị trí",
      "safari": "Safari: Tuỳ chọn → Trang web → Vị trí"
    },
    "notFound": {
      "title": "Không tìm thấy trang",
      "heading": "Trang không tồn tại",
      "message": "Trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển.",
      "goBack": "Quay lại",
      "backToHome": "Về trang chủ"
    },
    "maintenance": {
      "title": "Hệ thống đang bảo trì",
      "heading": "Đang bảo trì",
      "message": "Chúng tôi đang thực hiện bảo trì hệ thống. Vui lòng quay lại sau.",
      "learnMore": "Tìm hiểu thêm"
    },
    "general": {
      "title": "Đã xảy ra lỗi",
      "heading": "Có lỗi xảy ra",
      "message": "Đã xảy ra lỗi không mong muốn. Vui lòng thử lại sau.",
      "goBack": "Quay lại",
      "backToHome": "Về trang chủ"
    },
    "codes": {
      "VALIDATION_ERROR": "Lỗi xác thực dữ liệu",
      "NOT_FOUND": "Không tìm thấy {{resourceName}}",
      "UNAUTHORIZED": "Không có quyền truy cập",
      "FORBIDDEN": "Truy cập bị từ chối",
      "INTERNAL_SERVER_ERROR": "Lỗi máy chủ nội bộ",
      "BAD_REQUEST": "Yêu cầu không hợp lệ",
      "CONFLICT": "Xung đột dữ liệu",
      "DUPLICATE_ENTRY": "{{resourceName}} đã tồn tại",
      "INVALID_OPERATION": "Thao tác không hợp lệ",
      "INVALID_CREDENTIALS": "Thông tin đăng nhập không đúng",
      "TOKEN_EXPIRED": "Phiên đăng nhập đã hết hạn",
      "INSUFFICIENT_PERMISSIONS": "Không đủ quyền hạn",
      "ACCOUNT_LOCKED": "Tài khoản đã bị khóa",
      "PASSWORD_TOO_WEAK": "Mật khẩu quá yếu",
      "OLD_PASSWORD_INCORRECT": "Mật khẩu cũ không đúng",
      "EMPLOYEE_NOT_FOUND": "Không tìm thấy hồ sơ nhân viên",
      "EMPLOYEE_ALREADY_EXISTS": "Hồ sơ nhân viên đã tồn tại",
      "INVALID_ID_CARD": "Số CCCD không hợp lệ",
      "ID_CARD_ALREADY_EXISTS": "Số CCCD đã tồn tại",
      "INVALID_PHONE_NUMBER": "Số điện thoại không hợp lệ",
      "PHONE_NUMBER_ALREADY_EXISTS": "Số điện thoại đã tồn tại",
      "INVALID_EMAIL": "Email không hợp lệ",
      "EMAIL_ALREADY_EXISTS": "Email đã tồn tại",
      "EMPLOYEE_HAS_ACTIVE_CONTRACTS": "Nhân viên có hợp đồng lao động đang hoạt động",
      "EMPLOYEE_HAS_ACTIVE_ASSETS": "Nhân viên có tài sản đang sử dụng",
      "COMPANY_NOT_FOUND": "Không tìm thấy nhà máy",
      "COMPANY_ALREADY_EXISTS": "Nhà máy đã tồn tại",
      "COMPANY_HAS_EMPLOYEES": "Nhà máy có nhân viên đang làm việc",
      "EMPLOYEE_GROUP_NOT_FOUND": "Không tìm thấy nhóm nhân viên",
      "EMPLOYEE_GROUP_ALREADY_EXISTS": "Nhóm nhân viên đã tồn tại",
      "EMPLOYEE_GROUP_HAS_EMPLOYEES": "Nhóm nhân viên có nhân viên",
      "ROLE_NOT_FOUND": "Không tìm thấy vai trò",
      "ROLE_ALREADY_EXISTS": "Vai trò đã tồn tại",
      "ROLE_IS_DEFAULT": "Không thể xóa vai trò mặc định",
      "ROLE_HAS_USERS": "Vai trò có người dùng đang sử dụng",
      "PERMISSION_NOT_FOUND": "Không tìm thấy quyền hạn",
      "PERMISSION_ALREADY_EXISTS": "Quyền hạn đã tồn tại",
      "USER_NOT_FOUND": "Không tìm thấy người dùng",
      "USER_ALREADY_EXISTS": "Người dùng đã tồn tại",
      "USERNAME_ALREADY_EXISTS": "Tên đăng nhập đã tồn tại",
      "USER_IS_ACTIVE": "Người dùng đang hoạt động",
      "USER_HAS_ACTIVE_SESSIONS": "Người dùng có phiên đăng nhập đang hoạt động",
      "ASSET_NOT_FOUND": "Không tìm thấy mặt hàng",
      "ASSET_ALREADY_EXISTS": "Mặt hàng đã tồn tại",
      "ASSET_HAS_CONSUMPTION_HISTORY": "Mặt hàng có lịch sử tiêu dùng",
      "INSUFFICIENT_STOCK": "Không đủ hàng trong kho",
      "INVALID_QUANTITY": "Số lượng không hợp lệ",
      "INVALID_PRICE": "Giá không hợp lệ",
      "EMPLOYEE_ASSET_NOT_FOUND": "Không tìm thấy lịch sử tiêu dùng",
      "EMPLOYEE_ASSET_ALREADY_EXISTS": "Lịch sử tiêu dùng đã tồn tại",
      "INVALID_PAYMENT_STATUS": "Trạng thái thanh toán không hợp lệ",
      "EMPLOYEE_GIFT_NOT_FOUND": "Không tìm thấy quà tặng",
      "EMPLOYEE_GIFT_ALREADY_EXISTS": "Quà tặng đã tồn tại",
      "INVALID_GIFT_STATUS": "Trạng thái quà tặng không hợp lệ",
      "LEAVE_RECORD_NOT_FOUND": "Không tìm thấy bản ghi nghỉ làm",
      "LEAVE_RECORD_ALREADY_EXISTS": "Bản ghi nghỉ làm đã tồn tại",
      "INVALID_LEAVE_DATE": "Ngày nghỉ không hợp lệ",
      "LEAVE_DATE_IN_PAST": "Ngày nghỉ không thể trong quá khứ",
      "LEAVE_DATE_EXCEEDS_LIMIT": "Ngày nghỉ vượt quá giới hạn",
      "HOLIDAY_SETTING_NOT_FOUND": "Không tìm thấy cài đặt ngày nghỉ lễ",
      "HOLIDAY_SETTING_ALREADY_EXISTS": "Cài đặt ngày nghỉ lễ đã tồn tại",
      "INVALID_HOLIDAY_DATE": "Ngày nghỉ lễ không hợp lệ",
      "LABOR_CONTRACT_NOT_FOUND": "Không tìm thấy hợp đồng lao động",
      "LABOR_CONTRACT_ALREADY_EXISTS": "Hợp đồng lao động đã tồn tại",
      "INVALID_CONTRACT_DATE": "Ngày hợp đồng không hợp lệ",
      "CONTRACT_DATE_OVERLAP": "Ngày hợp đồng bị trùng lặp",
      "FILE_NOT_FOUND": "Không tìm thấy tệp",
      "FILE_ALREADY_EXISTS": "Tệp đã tồn tại",
      "FILE_TOO_LARGE": "Tệp quá lớn",
      "INVALID_FILE_TYPE": "Loại tệp không hợp lệ",
      "UPLOAD_FAILED": "Tải lên thất bại",
      "DOWNLOAD_FAILED": "Tải xuống thất bại",
      "DELETE_FAILED": "Xóa thất bại",
      "DORMITORY_NOT_FOUND": "Không tìm thấy ký túc xá",
      "DORMITORY_ALREADY_EXISTS": "Ký túc xá đã tồn tại",
      "POSITION_NOT_FOUND": "Không tìm thấy vị trí",
      "POSITION_ALREADY_OCCUPIED": "Vị trí đã được sử dụng",
      "POSITION_ALREADY_ASSIGNED": "Vị trí đã được gán",
      "INVALID_POSITION_TYPE": "Loại vị trí không hợp lệ",
      "HIERARCHY_CYCLE_DETECTED": "Phát hiện chu trình trong cấu trúc",
      "IMPORT_FAILED": "Nhập dữ liệu thất bại",
      "EXPORT_FAILED": "Xuất dữ liệu thất bại",
      "INVALID_FILE_FORMAT": "Định dạng tệp không hợp lệ",
      "TEMPLATE_NOT_FOUND": "Không tìm thấy mẫu",
      "VALIDATION_ERRORS_IN_FILE": "Có lỗi xác thực trong tệp",
      "DATABASE_CONNECTION_ERROR": "Lỗi kết nối cơ sở dữ liệu",
      "TRANSACTION_FAILED": "Giao dịch thất bại",
      "CONSTRAINT_VIOLATION": "Vi phạm ràng buộc dữ liệu",
      "EXTERNAL_SERVICE_ERROR": "Lỗi dịch vụ bên ngoài",
      "STORAGE_SERVICE_ERROR": "Lỗi dịch vụ lưu trữ",
      "EMAIL_SERVICE_ERROR": "Lỗi dịch vụ email",
      "SMS_SERVICE_ERROR": "Lỗi dịch vụ SMS"
    },
    "messages": {
      "validationError": "Vui lòng kiểm tra lại thông tin nhập",
      "notFound": "Không tìm thấy {{resourceName}}",
      "duplicateEntry": "{{resourceName}} đã tồn tại",
      "duplicateEntryWithField": "{{resourceName}} với {{fieldName}} '{{value}}' đã tồn tại",
      "insufficientPermissions": "Bạn không có đủ quyền để thực hiện thao tác này",
      "tryAgainLater": "Vui lòng thử lại sau",
      "contactAdmin": "Vui lòng liên hệ quản trị viên nếu vấn đề vẫn tiếp tục"
    }
  },
  "userActivities": {
    "title": "Nhật ký hoạt động",
    "description": "Theo dõi và xem lại các hoạt động của người dùng trong hệ thống",
    "searchPlaceholder": "Tìm kiếm người dùng...",
    "filters": "Bộ lọc",
    "applyFilters": "Áp dụng bộ lọc",
    "resetFilters": "Đặt lại bộ lọc",
    "resourceType": "Loại tài nguyên",
    "actionType": "Loại hành động",
    "dateRange": "Khoảng thời gian",
    "fromDate": "Từ ngày",
    "toDate": "Đến ngày",
    "allResourceTypes": "Tất cả tài nguyên",
    "allActionTypes": "Tất cả hành động",
    "selectResourceType": "Chọn loại tài nguyên",
    "selectActionType": "Chọn loại hành động",
    "viewDetails": "Xem chi tiết",
    "activityDetails": "Chi tiết hoạt động",
    "user": "Người dùng",
    "action": "Hành động",
    "resource": "Tài nguyên",
    "time": "Thời gian",
    "ipAddress": "Địa chỉ IP",
    "machineName": "Thiết bị",
    "changes": "Thay đổi",
    "changeDetails": "Chi tiết thay đổi",
    "actionDescription": "Mô tả hành động",
    "resourceId": "ID tài nguyên",
    "noActivities": "Không có hoạt động nào",
    "loadingActivities": "Đang tải hoạt động...",
    "errorLoadingActivities": "Có lỗi xảy ra khi tải dữ liệu",
    "refreshData": "Làm mới dữ liệu",
    "columnsToShow": "Cột hiển thị",
    "showColumns": "Hiện cột",
    "hideColumns": "Ẩn cột",
    "columnVisibility": "Hiển thị cột",
    "columns": {
      "userName": "Người dùng",
      "actionDescription": "Hành động",
      "resourceType": "Tài nguyên",
      "actionTime": "Thời gian",
      "ipAddress": "Địa chỉ IP",
      "machineName": "Thiết bị",
      "changes": "Thay đổi",
      "actions": "Thao tác"
    }
  },
  "userSessions": {
    "title": "Phiên đăng nhập",
    "description": "Quản lý và theo dõi các phiên đăng nhập đang hoạt động và lịch sử phiên",
    "tabs": {
      "active": "Hoạt động",
      "history": "Lịch sử"
    },
    "filters": {
      "title": "Bộ lọc",
      "username": "Tài khoản",
      "usernamePlaceholder": "Chọn tài khoản...",
      "usernameSearch": "Tìm theo username, email...",
      "noUsers": "Không tìm thấy tài khoản",
      "fromDate": "Từ ngày",
      "toDate": "Đến ngày",
      "selectDate": "Chọn ngày",
      "ipAddress": "Địa chỉ IP",
      "ipAddressPlaceholder": "VD: 192.168 hoặc 192.168.1.1",
      "apply": "Áp dụng",
      "reset": "Đặt lại"
    },
    "columns": {
      "username": "Người dùng",
      "status": "Trạng thái",
      "loginTime": "Đăng nhập",
      "lastActivity": "Hoạt động cuối",
      "logoutTime": "Đăng xuất",
      "activityDuration": "Thời gian hoạt động",
      "ipAddress": "Địa chỉ IP",
      "location": "Vị trí",
      "locationFromIp": "Vị trí từ IP",
      "locationFromClient": "Vị trí",
      "locationDenied": "Không đồng ý chia sẻ",
      "device": "Thiết bị",
      "actions": "Thao tác",
      "sessionId": "Session ID",
      "userAgent": "User Agent"
    },
    "viewDetails": "Xem chi tiết",
    "loading": "Đang tải phiên...",
    "noSessions": "Không có phiên nào",
    "revoke": "Thu hồi phiên",
    "revokeSuccess": "Đã thu hồi phiên thành công",
    "revokeError": "Không thể thu hồi phiên",
    "revokeConfirmTitle": "Thu hồi phiên đăng nhập",
    "revokeConfirmMessage": "Bạn có chắc muốn thu hồi phiên của {{username}}? Người dùng sẽ bị đăng xuất.",
    "paginationSummary": "Trang {{page}} / {{totalPages}} ({{total}} phiên)",
    "statistics": {
      "activeCount": "Phiên đang hoạt động",
      "loginsToday": "Đăng nhập hôm nay",
      "uniqueUsersToday": "Số người dùng hôm nay",
      "viewDetails": "Xem thống kê chi tiết",
      "pageTitle": "Thống kê phiên đăng nhập",
      "pageDescription": "Phân tích xu hướng đăng nhập, thiết bị và vị trí",
      "backToSessions": "Quay lại Phiên đăng nhập",
      "dateRange": "Khoảng thời gian",
      "trendsTitle": "Xu hướng đăng nhập",
      "trendsDescription": "Số lượng đăng nhập và người dùng theo ngày",
      "byDeviceTitle": "Theo thiết bị",
      "byDeviceDescription": "Phân bố phiên theo loại thiết bị",
      "byLocationTitle": "Theo vị trí",
      "byLocationDescription": "Top vị trí đăng nhập",
      "topUsersTitle": "Top người dùng",
      "topUsersDescription": "Người dùng có nhiều phiên đăng nhập nhất"
    }
  },
  "sidebar": {
    "toggleSidebar": "Mở/Đóng thanh bên",
    "mobileSidebarTitle": "Thanh bên",
    "mobileSidebarDescription": "Hiển thị thanh bên trên thiết bị di động.",
    "teams": {
      "employeeProfiles": "Hồ sơ"
    },
    "groups": {
      "general": "Chung",
      "pages": "Trang",
      "other": "Khác"
    },
    "items": {
      "employeeProfiles": "Hồ sơ",
      "userActivities": "Nhật ký hoạt động",
      "userSessions": "Phiên đăng nhập",
      "timeKeeping": "Chấm công",
      "leaveTracking": "Báo cáo ngày nghỉ",
      "holidaySetting": "Lịch nghỉ lễ",
      "leaveTrackingSettings": "Cài đặt lịch nghỉ",
      "profileDashboard": "Thống kê hồ sơ",
      "dashboard": "Dashboard",
      "tasks": "Công việc",
      "apps": "Ứng dụng",
      "chats": "Trò chuyện",
      "users": "Người dùng",
      "roles": "Vai trò - Quyền",
      "companies": "Nhà máy",
      "employeeGroups": "Nhóm nhân viên",
      "fileStorage": "Kế toán",
      "assets": "Quản lý mặt hàng",
      "assetManagement": "Mặt hàng",
      "assetConsumption": "Tiêu dùng mặt hàng",
      "auth": "Xác thực",
      "signIn": "Đăng nhập",
      "signIn2Col": "Đăng nhập (2 cột)",
      "signUp": "Đăng ký",
      "forgotPassword": "Quên mật khẩu",
      "otp": "OTP",
      "errors": "Lỗi",
      "unauthorized": "Không có quyền",
      "forbidden": "Bị cấm",
      "notFound": "Không tìm thấy",
      "internalServerError": "Lỗi máy chủ",
      "maintenanceError": "Bảo trì",
      "settings": "Cài đặt",
      "profile": "Cá nhân",
      "account": "Tài khoản",
      "appearance": "Giao diện",
      "notifications": "Thông báo",
      "display": "Hiển thị",
      "helpCenter": "Trung tâm trợ giúp"
    }
  },
  "users": {
    "title": "Quản lý người dùng",
    "description": "Quản lý người dùng và quyền của họ tại đây.",
    "addUser": "Tạo mới",
    "editUser": "Chỉnh sửa người dùng",
    "addUserDescription": "Tạo người dùng mới.",
    "editUserDescription": "Cập nhật thông tin người dùng.",
    "username": "Username",
    "fullName": "Họ tên",
    "phoneNumber": "Số điện thoại",
    "email": "Email",
    "password": "Mật khẩu",
    "confirmPassword": "Xác nhận mật khẩu",
    "status": "Trạng thái",
    "active": "Hoạt động",
    "inactive": "Không hoạt động",
    "permissions": "Quyền hạn",
    "usernameRequired": "Tên đăng nhập bắt buộc nhập.",
    "fullNameRequired": "Họ và tên bắt buộc nhập.",
    "phoneNumberRequired": "Số điện thoại bắt buộc nhập.",
    "emailInvalid": "Email không hợp lệ.",
    "passwordRequired": "Mật khẩu bắt buộc nhập.",
    "passwordMinLength": "Mật khẩu phải có ít nhất 8 ký tự.",
    "passwordLowercase": "Mật khẩu phải chứa ít nhất một chữ cái thường.",
    "passwordNumber": "Mật khẩu phải chứa ít nhất một chữ số.",
    "passwordMismatch": "Mật khẩu xác nhận không khớp.",
    "deleteUser": "Xóa người dùng",
    "deleteUserConfirm": "Bạn có chắc chắn muốn xóa người dùng này không?",
    "searchUsers": "Tìm kiếm người dùng...",
    "searchStatus": "Tìm kiếm trạng thái...",
    "accountType": "Loại tài khoản",
    "officeAccount": "Văn phòng",
    "workerAccount": "Công nhân",
    "view": "Xem",
    "userDetails": "Chi tiết người dùng",
    "viewPermissions": "Xem quyền hạn",
    "selectPermissions": "Chọn quyền hạn",
    "userCreated": "Đã tạo người dùng thành công",
    "userUpdated": "Đã cập nhật người dùng thành công",
    "userDeleted": "Đã xóa người dùng thành công",
    "userCreateError": "Lỗi khi tạo người dùng",
    "userUpdateError": "Lỗi khi cập nhật người dùng",
    "userDeleteError": "Lỗi khi xóa người dùng",
    "changePassword": "Đổi mật khẩu",
    "role": "Vai trò",
    "permission": "Quyền"
  },
  "companies": {
    "title": "Nhà máy",
    "description": "Quản lý thông tin nhà máy tại đây.",
    "addCompany": "Thêm nhà máy mới",
    "editCompany": "Chỉnh sửa nhà máy",
    "addCompanyDescription": "Tạo nhà máy mới.",
    "editCompanyDescription": "Cập nhật thông tin nhà máy.",
    "name": "Tên nhà máy",
    "address": "Địa chỉ",
    "note": "Ghi chú",
    "activeRentEmployees": "Nhân viên thuê",
    "status": "Trạng thái",
    "active": "Hoạt động",
    "inactive": "Không hoạt động",
    "nameRequired": "Tên nhà máy bắt buộc nhập.",
    "addressRequired": "Địa chỉ bắt buộc nhập.",
    "deleteCompany": "Xóa nhà máy",
    "deleteCompanyConfirm": "Bạn có chắc chắn muốn xóa nhà máy này không?",
    "searchCompanies": "Tìm kiếm nhà máy...",
    "searchStatus": "Tìm kiếm trạng thái...",
    "companyDetails": "Chi tiết nhà máy",
    "companyCreated": "Đã tạo nhà máy thành công",
    "companyUpdated": "Đã cập nhật nhà máy thành công",
    "companyDeleted": "Đã xóa nhà máy thành công",
    "employees": "Nhân viên",
    "addEmployee": "Thêm hồ sơ",
    "removeEmployee": "Xóa hồ sơ",
    "employeeAdded": "Đã thêm hồ sơ vào nhà máy thành công",
    "employeeRemoved": "Đã xóa hồ sơ khỏi nhà máy thành công",
    "numberOfEmployee": "Số lượng công nhân",
    "salarySetting": "Cài đặt tiền lương",
    "currentSalarySetting": "Cài đặt tiền lương hiện tại",
    "applyDate": "Ngày áp dụng",
    "regularDayShiftRate": "HC ca ngày",
    "overtimeDayShiftRate": "Tăng ca ngày",
    "regularNightShiftRate": "HC ca đêm",
    "overtimeNightShiftRate": "Tăng ca đêm",
    "regularSundayRate": "HC Chủ nhật",
    "overtimeSundayRate": "Tăng ca Chủ nhật",
    "regularSundayNightRate": "HC ca đêm Chủ nhật",
    "overtimeSundayNightRate": "Tăng ca ca đêm Chủ nhật",
    "regularHolidayRate": "HC Ngày lễ",
    "overtimeHolidayRate": "Tăng ca Ngày lễ",
    "regularTetRate": "HC Ngày Tết",
    "overtimeTetRate": "Tăng ca Ngày Tết",
    "attendanceAllowance26Days": "PC chuyên cần 26 ngày",
    "attendanceAllowance30Days": "PC chuyên cần 30 ngày",
    "showSalarySettings": "Hiện",
    "hideSalarySettings": "Ẩn",
    "createdBy": "Tạo bởi",
    "updatedBy": "Cập nhật bởi",
    "salarySettingHistory": "Lịch sử cài đặt lương",
    "selectFromHistory": "Chọn từ lịch sử",
    "noHistory": "Chưa có lịch sử",
    "createdAt": "Ngày tạo",
    "updatedAt": "Ngày cập nhật",
    "manageSalarySettings": "Cài đặt lương",
    "salarySettings": "Cài đặt lương",
    "salarySettingsDescription": "Quản lý các mức lương theo thời gian.",
    "createSalarySetting": "Tạo cài đặt lương mới",
    "createSalarySettingDescription": "Thêm một cài đặt lương mới.",
    "editSalarySetting": "Chỉnh sửa cài đặt lương",
    "editSalarySettingDescription": "Cập nhật thông tin cài đặt lương.",
    "noSalarySettings": "Chưa có cài đặt lương nào.",
    "confirmDeleteSalarySetting": "Bạn có chắc chắn muốn xóa cài đặt lương này không?",
    "salarySettingCreated": "Đã tạo cài đặt lương thành công",
    "salarySettingUpdated": "Đã cập nhật cài đặt lương thành công",
    "salarySettingDeleted": "Đã xóa cài đặt lương thành công",
    "salaryRecalculated": "Đã tính lại lương thành công",
    "salaryRates": "Mức lương",
    "startFrom": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "selectDate": "Chọn ngày",
    "indefinite": "Không xác định",
    "recalculateSalaryTitle": "Xác nhận tính lại lương cho ngày công đã tạo",
    "recalculateSalaryMessage": "Áp dụng thay đổi mức lương cho các ngày công đã tạo? Hành động này không thể hoàn tác.",
    "leaveDateSettings": "Cài đặt nghỉ phép",
    "leaveDateSettingCreated": "Đã tạo cài đặt nghỉ phép thành công",
    "leaveDateSettingUpdated": "Đã cập nhật cài đặt nghỉ phép thành công",
    "leaveDateSettingDeleted": "Đã xóa cài đặt nghỉ phép thành công",
    "leaveDateSettingDetails": "Chi tiết cài đặt nghỉ phép",
    "leaveDateSettingCreatedBy": "Tạo bởi",
    "leaveDateSettingUpdatedBy": "Cập nhật bởi",
    "leaveDateSettingCreatedAt": "Ngày tạo",
    "leaveDateSettingUpdatedAt": "Ngày cập nhật",
    "leaveDateSettingStartFrom": "Ngày bắt đầu",
    "leaveDateSettingEndDate": "Ngày kết thúc",
    "leaveDateSettingNumberAllowDate": "Số ngày nghỉ",
    "leaveDateSettingType": "Loại nghỉ",
    "leaveDateSettingTypeMonth": "Tháng",
    "leaveDateSettingTypeYear": "Năm",
    "leaveDateSettingNumberAllowDateRequired": "Số ngày nghỉ bắt buộc nhập.",
    "leaveDateSettingTypeRequired": "Loại nghỉ bắt buộc nhập.",
    "leaveDateSettingStartFromRequired": "Ngày bắt đầu bắt buộc nhập.",
    "leaveDateSettingEndDateRequired": "Ngày kết thúc bắt buộc nhập.",
    "leaveDateSettingNumberAllowDateMin": "Số ngày nghỉ phải >= 0.",
    "leaveDateSettingTypeMin": "Loại nghỉ phải là Tháng hoặc Năm.",
    "leaveDateSettingStartFromMin": "Ngày bắt đầu phải là ngày hiện tại hoặc sau ngày hiện tại.",
    "createLeaveDateSetting": "Tạo cài đặt nghỉ phép",
    "createLeaveDateSettingDescription": "Thêm một cài đặt nghỉ phép mới.",
    "editLeaveDateSetting": "Chỉnh sửa cài đặt nghỉ phép",
    "numberAllowLeave": "Số ngày nghỉ",
    "leaveDateType": "Phạm vi",
    "leaveDateSettingsDescription": "Cài đặt số ngày nghỉ cho phép",
    "noLeaveDateSettings": "Chưa có cài đặt nào.",
    "manageLeaveDateSettings": "Phạm vi nghỉ",
    "year": "Năm",
    "month": "Tháng",
  },
  "employeeGroups": {
    "title": "Quản lý nhóm nhân viên",
    "description": "Quản lý thông tin nhóm nhân viên tại đây.",
    "descriptionHeader": "Mô tả",
    "addEmployeeGroup": "Thêm nhóm mới",
    "editEmployeeGroup": "Chỉnh sửa nhóm",
    "addEmployeeGroupDescription": "Tạo nhóm nhân viên mới.",
    "editEmployeeGroupDescription": "Cập nhật thông tin nhóm nhân viên.",
    "name": "Tên nhóm",
    "status": "Trạng thái",
    "active": "Hoạt động",
    "inactive": "Không hoạt động",
    "nameRequired": "Tên nhóm bắt buộc nhập.",
    "deleteEmployeeGroup": "Xóa nhóm",
    "deleteEmployeeGroupConfirm": "Bạn có chắc chắn muốn xóa nhóm này không?",
    "searchEmployeeGroups": "Tìm kiếm nhóm...",
    "searchStatus": "Tìm kiếm trạng thái...",
    "employeeGroupDetails": "Chi tiết nhóm",
    "employeeGroupCreated": "Đã tạo nhóm thành công",
    "employeeGroupUpdated": "Đã cập nhật nhóm thành công",
    "employeeGroupDeleted": "Đã xóa nhóm thành công"
  },
  "leaveTracking": {
    "title": "Quản lý nghỉ làm",
    "description": "Theo dõi và quản lý thông tin nghỉ làm của công nhân.",
    "dailyView": "Ngày",
    "weeklyView": "Tuần",
    "customRange": "Tuỳ chỉnh",
    "totalLeavesToday": "Tổng nghỉ hôm nay",
    "totalLeavesThisWeek": "Tổng nghỉ tuần này",
    "ofTotal": "của tổng",
    "leaveRecords": "Danh sách nghỉ làm",
    "addRecord": "Thêm bản ghi",
    "editRecord": "Chỉnh sửa bản ghi",
    "employee": "Công nhân",
    "employeeId": "Mã công nhân",
    "group": "Nhóm",
    "leaveDate": "Ngày nghỉ",
    "leaveType": "Loại nghỉ",
    "timekeepingType": "Loại chấm công",
    "timekeepingTitle": "Bảng chấm công",
    "timekeepingDescription": "Theo dõi và quản lý bảng chấm công",
    "reason": "Lý do",
    "note": "Ghi chú",
    "searchByName": "Tìm theo tên...",
    "searchByGroup": "Tìm theo nhóm...",
    "selectLeaveType": "Chọn loại nghỉ",
    "allTypes": "Tất cả loại",
    "startDate": "Từ ngày",
    "endDate": "Đến ngày",
    "search": "Tìm kiếm",
    "export": "Xuất báo cáo",
    "noRecords": "Không có bản ghi nào",
    "confirmDelete": "Bạn có chắc chắn muốn xóa bản ghi này?",
    "confirmDeleteDesc": "Công nhân: {{employee}} | Nhóm: {{group}} | Ngày nghỉ: {{date}}",
    "deleteSuccess": "Đã xóa bản ghi thành công",
    "deleteError": "Lỗi khi xóa bản ghi",
    "exportSuccess": "Đã xuất báo cáo thành công",
    "exportError": "Lỗi khi xuất báo cáo",
    "fillRequiredFields": "Vui lòng điền đầy đủ thông tin bắt buộc",
    "endDateMustBeAfterStartDate": "Ngày kết thúc phải lớn hơn hoặc bằng ngày bắt đầu",
    "createSuccess": "Đã tạo bản ghi thành công",
    "createError": "Lỗi khi tạo bản ghi",
    "updateSuccess": "Đã cập nhật bản ghi thành công",
    "updateError": "Lỗi khi cập nhật bản ghi",
    "deleteRecordError": "Có lỗi xảy ra khi xóa bản ghi nghỉ làm",
    "updateCompanyError": "Có lỗi xảy ra khi cập nhật công ty",
    "recordNotFound": "Không tìm thấy bản ghi",
    "findEmployeePlaceholder": "Tìm hồ sơ bằng STT, Tên, CCCD",
    "selectDate": "Chọn ngày",
    "enterReason": "Nhập lý do...",
    "enterNote": "Nhập ghi chú...",
    "company": "Nhà máy"
  },
  "timekeeping": {
    "title": "Quản lý chấm công",
    "description": "Quản lý và theo dõi chấm công của công nhân.",
    "timekeepingRecords": "Danh sách chấm công",
    "addRecord": "Thêm bản ghi",
    "editRecord": "Chỉnh sửa bản ghi",
    "employee": "Công nhân",
    "employeeId": "Mã công nhân",
    "leaveDate": "Ngày chấm công",
    "timekeepingType": "Loại chấm công",
    "reason": "Lý do",
    "note": "Ghi chú",
    "searchByName": "Tìm theo tên...",
    "selectLeaveType": "Chọn loại chấm công",
    "allTypes": "Tất cả loại",
    "startDate": "Từ ngày",
    "endDate": "Đến ngày",
    "export": "Xuất báo cáo",
    "noRecords": "Không có bản ghi nào",
    "confirmDelete": "Bạn có chắc chắn muốn xóa bản ghi này?",
    "confirmDeleteDesc": "Công nhân: {{employee}} | Nhóm: {{group}} | Ngày: {{date}}",
    "deleteSuccess": "Đã xóa bản ghi thành công",
    "deleteError": "Lỗi khi xóa bản ghi",
    "exportSuccess": "Đã xuất báo cáo thành công",
    "exportError": "Lỗi khi xuất báo cáo",
    "deleteRecordError": "Có lỗi xảy ra khi xóa bản ghi nghỉ làm",
    "updateCompanyError": "Có lỗi xảy ra khi cập nhật công ty",
    "updateDateError": "Có lỗi xảy ra khi cập nhật ngày giao dịch"
  },
  "employees": {
    "title": "Hồ sơ nhân sự",
    "description": "Quản lý hồ sơ.",
    "addEmployeeProfile": "Thêm hồ sơ",
    "editEmployeeProfile": "Chỉnh sửa hồ sơ",
    "deleteEmployee": "Xóa hồ sơ",
    "deleteEmployeeConfirm": "Bạn có chắc chắn muốn xóa hồ sơ này không?",
    "seqNumber": "STT",
    "name": "Họ tên",
    "idCardNumber": "CCCD",
    "gender": "Giới tính",
    "male": "Nam",
    "female": "Nữ",
    "unknown": "-",
    "dob": "Ngày sinh",
    "yob": "Năm sinh",
    "yearOfBirth": "Năm sinh",
    "monthOfBirth": "Tháng sinh",
    "address": "Địa chỉ",
    "group": "Nhóm",
    "startDate": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "createdAt": "Ngày tạo",
    "noEmployeesFound": "Không tìm thấy hồ sơ nào",
    "searchEmployees": "Tìm kiếm hồ sơ...",
    "searchGroup": "Tìm kiếm nhóm...",
    "idCardIssueDate": "Ngày cấp CCCD",
    "idCardExpireDate": "Ngày hết hạn CCCD",
    "idCardIssuePlace": "Nơi cấp CCCD",
    "nationality": "Quốc tịch",
    "religion": {
      "kinh": "Kinh",
      "minority": "Đồng bào"
    },
    "religionHeader": "Tôn giáo",
    "note": "Ghi chú",
    "profileType": "Loại hồ sơ",
    "profileTypes": {
      "official": "Chính thức",
      "partTime": "Thời vụ",
      "banned": "DS Cấm"
    },
    "official": "Chính thức",
    "temporary": "Thời vụ",
    "employeeCreated": "Đã tạo hồ sơ thành công",
    "employeeUpdated": "Đã cập nhật hồ sơ thành công",
    "employeeDeleted": "Đã xóa hồ sơ thành công",
    "employeeCreateError": "Tạo hồ sơ lỗi",
    "employeeUpdateError": "Lỗi cập nhật hồ sơ",
    "fillRequiredFieldsPersonal": "Vui lòng điền đầy đủ thông tin bắt buộc trong tab Sơ yếu lý lịch",
    "fillRequiredFieldsWorking": "Vui lòng điền đầy đủ thông tin bắt buộc trong tab Công việc",
    "fillRequiredFieldsPackage": "Vui lòng điền đầy đủ thông tin bắt buộc trong tab Gói đăng kí",
    "fillRequiredAttachments": "Vui lòng tải lên đầy đủ tệp đính kèm bắt buộc",
    "fillRequiredFieldsCheck": "Vui lòng kiểm tra và điền đầy đủ thông tin bắt buộc",
    "attachmentUploadSuccess": "Tệp đính kèm được tải lên thành công",
    "attachmentUploadError": "Lỗi tải lên tệp đính kèm",
    "attachmentDeleteSuccess": "Tệp đính kèm đã được xóa",
    "attachmentDeleteError": "Lỗi xóa tệp đính kèm",
    "fileSizeLimit": "Kích thước tệp phải nhỏ hơn 20MB",
    "packageEndDateApplied": "Đã áp dụng ngày kết thúc gói đăng kí",
    "attachmentDescriptionRequired": "Vui lòng nhập mô tả cho tệp đính kèm",
    "selectViolationType": "Vui lòng chọn loại vi phạm",
    "incidentAddSuccess": "Thêm vi phạm thành công",
    "incidentAddError": "Lỗi khi thêm vi phạm",
    "incidentUpdateSuccess": "Cập nhật vi phạm thành công",
    "incidentUpdateError": "Lỗi khi cập nhật vi phạm",
    "incidentDeleteSuccess": "Xóa vi phạm thành công",
    "incidentDeleteError": "Lỗi khi xóa vi phạm",
    "positionHistoryCreateSuccess": "Lịch sử công việc được tạo thành công",
    "positionHistoryCreateError": "Lỗi khi tạo lịch sử công việc",
    "positionHistoryUpdateSuccess": "Lịch sử công việc được cập nhật thành công",
    "positionHistoryUpdateError": "Lỗi khi cập nhật lịch sử công việc",
    "positionHistoryDeleteSuccess": "Lịch sử công việc được xóa thành công",
    "positionHistoryDeleteError": "Lỗi khi xóa lịch sử công việc",
    "details": "Chi tiết hồ sơ",
    "importEmployees": "Nhập hồ sơ",
    "importDescription": "Nhập hồ sơ từ file Csv, Excel.",
    "dragAndDropOrClick": "Kéo và thả hoặc nhấp để tải lên file",
    "phoneNumber": "SĐT",
    "workShift": "Ca làm",
    "workShifts": {
      "day": "Ca ngày",
      "night": "Ca đêm"
    },
    "province": "Tỉnh/Thành phố",
    "district": "Quận/Huyện",
    "ward": "Phường/Xã",
    "selectProvince": "Chọn tỉnh",
    "selectDistrict": "Chọn huyện",
    "selectWard": "Chọn xã",
    "selectGender": "Chọn giới tính",
    "selectProfileType": "Chọn loại hồ sơ",
    "selectFactory": "Chọn nhà máy",
    "allGenders": "Tất cả",
    "allProfileTypes": "Tất cả loại hồ sơ",
    "defaultFactoryFilter": "Không lọc",
    "searchFactory": "Tìm kiếm nhà máy",
    "noFactoriesFound": "Không tìm thấy nhà máy",
    "noProvincesFound": "Không tìm thấy tỉnh/thành phố",
    "noDistrictsFound": "Không tìm thấy quận/huyện",
    "noWardsFound": "Không tìm thấy phường/xã",
    "searchProvince": "Tìm kiếm tỉnh/thành phố",
    "searchDistrict": "Tìm kiếm quận/huyện",
    "searchWard": "Tìm kiếm phường/xã",
    "location": "Địa điểm",
    "applyFilters": "Áp dụng bộ lọc",
    "resetFilters": "Đặt lại bộ lọc",
    "searchTextPlaceholder": "Tên, STT, CCCD, SĐT",
    "fullNameRequired": "Họ tên phải có ít nhất 2 ký tự",
    "idCardRequired": "Số CCCD là bắt buộc",
    "idCardLengthInvalid": "Số CCCD phải có 9 hoặc 12 ký tự",
    "employeeGroup": "Mã nhóm",
    "selectGroup": "Chọn mã nhóm",
    "working": {
      "title": "Việc làm",
      "formTitle": "Thông tin việc làm",
      "current": "Hiện tại",
      "history": "Lịch sử",
      "company": "Nhà máy",
      "position": "Vị trí",
      "startDate": "Ngày bắt đầu",
      "endDate": "Ngày kết thúc",
      "note": "Ghi chú",
      "unassign": "Huỷ gán",
      "edit": "Chỉnh sửa",
      "save": "Lưu",
      "cancel": "Huỷ",
      "noHistory": "Chưa có lịch sử vị trí làm việc",
      "loading": "Đang tải...",
      "success": "Cập nhật thành công",
      "error": "Có lỗi xảy ra",
      "viewMore": "Xem thêm",
      "viewLess": "Thu gọn",
      "loadMore": "Tải thêm",
      "noMoreHistory": "Không còn lịch sử",
      "validation": {
        "companyRequired": "Vui lòng chọn nhà máy",
        "positionRequired": "Vui lòng nhập vị trí",
        "positionMaxLength": "Vị trí không được vượt quá {{maxLength}} ký tự",
        "noteMaxLength": "Ghi chú không được vượt quá {{maxLength}} ký tự",
        "endDateAfterStart": "Ngày kết thúc phải sau ngày bắt đầu",
        "passwordMismatch": "Mật khẩu xác nhận không khớp",
        "email": "Email không hợp lệ",
        "required": "Bắt buộc nhập"
      },
    },
    "unassigned": "Chưa gán",
    "temporaryResidence": "Nơi ở tạm trú",
    "temporaryResidence.dormitory": "Ký túc xá (cũ)",
    "temporaryResidence.dormitoryThuthua": "Ký túc xá Thủ Thừa",
    "temporaryResidence.dormitoryQ7": "Ký túc xá Q7",
    "temporaryResidence.dormitoryHiepPhuoc": "Ký túc xá Hiệp Phước",
    "temporaryResidence.dormitoryBenLuc": "Ký túc xá Bến Lức",
    "temporaryResidence.outsideResidence": "Trọ bên ngoài",
    "temporaryResidence.other": "Khác",
    "viewEmployee": "Xem hồ sơ",
    "selectQuickFilter": "Lọc nhanh",
    "noQuickFilter": "Tất cả"
  },
  "import": {
    "overwriteExisting": "Ghi đè hồ sơ đã tồn tại theo số CCCD",
    "upload": "Tải lên",
    "uploading": "Đang tải lên...",
    "unsupportedFormat": "Định dạng tệp không được hỗ trợ",
    "supportedFormats": "Vui lòng tải lên tệp .xlsx hoặc .csv",
    "errorsFound": "Phát hiện lỗi trong dữ liệu nhập",
    "importCompletedWithErrors": "Nhập dữ liệu hoàn tất với lỗi",
    "downloadErrorReport": "Tải xuống báo cáo lỗi",
    "importSuccessful": "Nhập dữ liệu thành công",
    "importFailed": "Nhập dữ liệu thất bại",
    "unknownError": "Đã xảy ra lỗi không xác định",
    "recordsImported": "Đã nhập {{count}} bản ghi",
    "importCompletedWithResults": "Đã nhập thành công {{success}} bản ghi, {{error}} bản ghi lỗi",
    "importCompleted": "Hoàn thành nhập dữ liệu",
    "downloadTemplate": "Tải xuống mẫu nhập dữ liệu"
  },
  "gender": {
    "male": "Nam",
    "female": "Nữ",
    "unknown": "Không rõ",
    "all": "Tất cả"
  },
  "fileStorage": {
    "title": "Dữ liệu kế toán",
    "description": "Quản lý dữ liệu kế toán",
    "createFolder": "Tạo thư mục",
    "uploadFile": "Tải lên tệp",
    "uploadFiles": "Tải lên tệp",
    "download": "Tải xuống",
    "rename": "Đổi tên",
    "move": "Di chuyển",
    "copy": "Sao chép",
    "delete": "Xóa",
    "properties": "Thuộc tính",
    "newFolder": "Thư mục mới",
    "folderName": "Tên thư mục",
    "fileName": "Tên tệp",
    "fileSize": "Kích thước",
    "fileType": "Loại tệp",
    "dateCreated": "Ngày tạo",
    "dateModified": "Ngày sửa đổi",
    "createdBy": "Tạo bởi",
    "modifiedBy": "Sửa đổi bởi",
    "selectFiles": "Chọn tệp",
    "dragAndDrop": "Kéo và thả tệp vào đây hoặc",
    "clickToSelect": "nhấp để chọn",
    "uploading": "Đang tải lên...",
    "uploadComplete": "Tải lên hoàn tất",
    "uploadFailed": "Tải lên thất bại",
    "deleteConfirm": "Bạn có chắc chắn muốn xóa {{count}} mục đã chọn?",
    "deleteSuccess": "Đã xóa thành công",
    "deleteFailed": "Xóa thất bại",
    "renameSuccess": "Đổi tên thành công",
    "renameFailed": "Đổi tên thất bại",
    "createFolderSuccess": "Tạo thư mục thành công",
    "createFolderFailed": "Tạo thư mục thất bại",
    "moveSuccess": "Di chuyển thành công",
    "moveFailed": "Di chuyển thất bại",
    "itemCount": "{{count}} mục",
    "selectedCount": "{{count}} đã chọn",
    "gridView": "Xem dạng lưới",
    "listView": "Xem dạng danh sách",
    "sortBy": "Sắp xếp theo",
    "sortByName": "Tên",
    "sortBySize": "Kích thước",
    "sortByDate": "Ngày",
    "sortByType": "Loại",
    "filterByType": "Lọc theo loại",
    "allTypes": "Tất cả loại",
    "folders": "Thư mục",
    "files": "Tệp",
    "images": "Hình ảnh",
    "documents": "Tài liệu",
    "videos": "Video",
    "audio": "Âm thanh",
    "archives": "Nén",
    "others": "Khác",
    "noItems": "Không có mục nào",
    "noItemsDescription": "Thư mục này trống. Tạo thư mục mới hoặc tải lên tệp.",
    "searchPlaceholder": "Tìm kiếm tệp và thư mục...",
    "home": "Trang chủ",
    "back": "Quay lại",
    "forward": "Tiến",
    "refresh": "Làm mới",
    "selectAll": "Chọn tất cả",
    "deselectAll": "Bỏ chọn tất cả",
    "cut": "Cắt",
    "paste": "Dán",
    "preview": "Xem trước",
    "details": "Chi tiết",
    "share": "Chia sẻ",
    "permissions": "Quyền",
    "tags": "Thẻ",
    "folderNamePlaceholder": "Tên thư mục",
    "dragAndDropFiles": "Kéo và thả tệp vào đây hoặc",
    "addTag": "Thêm thẻ",
    "removeTag": "Xóa thẻ",
    "selectTags": "Chọn thẻ...",
    "searchTags": "Tìm kiếm thẻ...",
    "noTagsFound": "Không tìm thấy thẻ",
    "editDescription": "Chỉnh sửa mô tả",
    "saveDescription": "Lưu mô tả",
    "cancelEdit": "Huỷ chỉnh sửa",
    "confirmDeleteSingle": "Bạn có chắc chắn muốn xóa tệp này không?",
    "confirmDeleteMultiple": "Bạn có chắc chắn muốn xóa {{count}} tệp đã chọn không?",
    "uploadingFiles": "Đang tải lên {{count}} tệp...",
  },
  "auth": {
    "title": "Hoàng Mai Group",
    "newPassword": "Mật khẩu mới",
    "confirmPassword": "Xác nhận mật khẩu",
    "oldPassword": "Mật khẩu cũ",
    "changePasswordDescription": "Đổi mật khẩu cho tài khoản",
    "changePasswordSuccess": "Đổi mật khẩu thành công",
    "changePasswordError": "Đổi mật khẩu thất bại",
    "signIn": {
      "title": "Đăng nhập",
      "description": "Đăng nhập vào hệ thống",
      "username": "Tên đăng nhập",
      "password": "Mật khẩu",
      "forgotPassword": "Quên mật khẩu?",
      "quote": "Đăng nhập vào hệ thống",
      "usernameRequired": "Vui lòng nhập tên đăng nhập",
      "passwordRequired": "Vui lòng nhập mật khẩu",
      "success": "Đăng nhập thành công",
      "error": "Tên đăng nhập hoặc mật khẩu không đúng",
      "changePassword": "Đổi mật khẩu",
      "newPassword": "Mật khẩu mới",
      "oldPassword": "Mật khẩu cũ",
      "confirmPassword": "Xác nhận mật khẩu",
      "changePasswordDescription": "Đổi mật khẩu cho tài khoản",
      "changePasswordSuccess": "Đổi mật khẩu thành công",
      "changePasswordError": "Đổi mật khẩu thất bại"
    },
    "signUp": {
      "title": "Đăng ký",
      "description": "Đăng ký tài khoản mới",
      "username": "Tên đăng nhập",
      "password": "Mật khẩu",
      "confirmPassword": "Xác nhận mật khẩu",
      "forgotPassword": "Quên mật khẩu?",
      "quote": "Đăng ký tài khoản mới"
    },
    "passwordMinLength": "Mật khẩu phải có ít nhất 8 ký tự.",
    "passwordMismatch": "Mật khẩu xác nhận không khớp.",
    "passwordRequired": "Mật khẩu là bắt buộc.",
    "passwordLowercase": "Mật khẩu phải chứa ít nhất một chữ cái thường.",
    "passwordNumber": "Mật khẩu phải chứa ít nhất một chữ số.",
    "passwordUppercase": "Mật khẩu phải chứa ít nhất một chữ cái viết hoa.",
    "passwordSpecialChar": "Mật khẩu phải chứa ít nhất một ký tự đặc biệt.",
    "logout": "Đăng xuất"
  },
  "roles": {
    "title": "Danh sách vai trò",
    "description": "Mô tả",
    "addRole": "Thêm vai trò mới",
    "editRole": "Chỉnh sửa vai trò",
    "addRoleDescription": "Tạo vai trò mới.",
    "editRoleDescription": "Cập nhật thông tin vai trò.",
    "name": "Tên vai trò",
    "roleDescription": "Mô tả",
    "type": "Loại",
    "default": "Mặc định",
    "custom": "Tuỳ chỉnh",
    "permissionCount": "Số quyền",
    "nameRequired": "Tên vai trò bắt buộc nhập.",
    "descriptionRequired": "Mô tả bắt buộc nhập.",
    "deleteRole": "Xóa vai trò",
    "deleteRoleConfirm": "Bạn có chắc chắn muốn xóa vai trò này không?",
    "searchRoles": "Tìm kiếm vai trò...",
    "roleDetails": "Chi tiết vai trò",
    "roleCreated": "Đã tạo vai trò thành công",
    "roleUpdated": "Đã cập nhật vai trò thành công",
    "roleDeleted": "Đã xóa vai trò thành công",
    "roleCreateError": "Lỗi khi tạo vai trò",
    "roleUpdateError": "Lỗi khi cập nhật vai trò",
    "roleDeleteError": "Lỗi khi xóa vai trò",
    "roleDuplicateSuccess": "Tạo bản sao vai trò thành công",
    "roleDuplicateError": "Lỗi khi tạo bản sao vai trò",
    "permissions": "Quyền hạn",
    "selectPermissions": "Chọn quyền hạn",
    "viewPermissions": "Xem quyền hạn",
    "defaultRoleEditDisabled": "Không được chỉnh sửa vai trò mặc định",
    "defaultRoles": {
      "Admin": "Quản trị viên",
      "HR": "Nhân sự",
      "Accountant": "Kế toán",
      "Employee": "Nhân viên"
    },
    "descriptions": {
      "Admin": "Quản trị viên hệ thống với đầy đủ quyền hạn",
      "HR": "Vai trò nhân sự với quyền quản lý hồ sơ",
      "Accountant": "Vai trò kế toán với quyền quản lý tài chính",
      "Employee": "Vai trò nhân viên với quyền cơ bản"
    },
    "userCount": "Số người",
  },
  "activityLogs": {
    "title": "Nhật ký hoạt động người dùng",
    "description": "Theo dõi và xem lại các hoạt động của người dùng trong hệ thống",
    "searchPlaceholder": "Tìm kiếm theo tên người dùng...",
    "filterTitle": "Bộ lọc hoạt động",
    "username": "Người dùng",
    "objectType": "Loại đối tượng",
    "actionType": "Hành động",
    "objectName": "Tên đối tượng",
    "dateRange": "Khoảng thời gian",
    "allObjectTypes": "Tất cả loại đối tượng",
    "allActions": "Tất cả hành động",
    "selectDateRange": "Chọn khoảng thời gian",
    "descriptionColumn": "Mô tả",
    "objectColumn": "Đối tượng",
    "timeColumn": "Thời gian",
    "actionsColumn": "Thao tác",
    "viewDetails": "Xem chi tiết",
    "noActivities": "Không có hoạt động nào",
    "totalActivities": "Tổng {{count}} hoạt động",
    "enterUsername": "Nhập tên người dùng",
    "enterObjectName": "Nhập tên đối tượng",
  },
  "permissions": {
    "role.view": "Xem vai trò",
    "role.create": "Tạo vai trò",
    "role.edit": "Chỉnh sửa vai trò",
    "role.delete": "Xóa vai trò",
    "user.view": "Xem người dùng",
    "user.create": "Tạo người dùng",
    "user.edit": "Chỉnh sửa người dùng",
    "user.delete": "Xóa người dùng",
    "employee.view": "Xem hồ sơ",
    "employee.create": "Tạo hồ sơ",
    "employee.edit": "Chỉnh sửa hồ sơ",
    "employee.delete": "Xóa hồ sơ",
    "employee.export": "Xuất file hồ sơ",
    "employee.assignFactory": "Gán nhà máy cho hồ sơ",
    "company.view": "Xem nhà máy",
    "company.create": "Tạo nhà máy",
    "company.edit": "Chỉnh sửa nhà máy",
    "company.delete": "Xóa nhà máy",
    "employeeGroup.view": "Xem nhóm nhân viên",
    "employeeGroup.create": "Tạo nhóm nhân viên",
    "employeeGroup.edit": "Chỉnh sửa nhóm nhân viên",
    "employeeGroup.delete": "Xóa nhóm nhân viên",
    "filestorage.view": "Xem tệp",
    "filestorage.create": "Tạo tệp/thư mục",
    "filestorage.edit": "Chỉnh sửa tệp/thư mục",
    "filestorage.delete": "Xóa tệp/thư mục",
    "filestorage.admin": "Quản trị tệp",
    "personal.view": "Xem thông tin cá nhân",
    "personal.edit": "Chỉnh sửa thông tin cá nhân",
    "personal.changePassword": "Đổi mật khẩu",
    "asset.view": "Xem mặt hàng",
    "asset.create": "Tạo mặt hàng",
    "asset.edit": "Chỉnh sửa mặt hàng",
    "asset.delete": "Xóa mặt hàng"
  },
  "employeeAssets": {
    "title": "Danh sách tiêu dùng",
    "description": "Quản lý lịch sử tiêu dùng mặt hàng của nhân viên.",
    "consumption": "Tiêu dùng",
    "consumptionTitle": "Quản lý tiêu dùng - {{employeeName}}",
    "addConsumption": "Thêm tiêu dùng",
    "editConsumption": "Chỉnh sửa tiêu dùng",
    "deleteConsumption": "Xóa tiêu dùng",
    "addConsumptionDescription": "Thêm lịch sử tiêu dùng mặt hàng cho nhân viên.",
    "editConsumptionDescription": "Cập nhật thông tin tiêu dùng mặt hàng.",
    "deleteConsumptionConfirm": "Bạn có chắc chắn muốn xóa bản ghi tiêu dùng này không?",
    "employee": "Công nhân",
    "asset": "Mặt hàng",
    "quantity": "Số lượng",
    "paymentStatus": "Trạng thái thanh toán",
    "boughtAt": "Ngày mua",
    "purchaseDate": "Ngày mua",
    "totalAmount": "Tổng tiền",
    "selectEmployee": "Chọn nhân viên",
    "selectAsset": "Mặt hàng",
    "searchEmployees": "Tìm kiếm nhân viên...",
    "searchAssets": "Tìm kiếm mặt hàng...",
    "noEmployeesFound": "Không tìm thấy nhân viên",
    "noAssetsFound": "Không tìm thấy mặt hàng",
    "consumptionCreated": "Đã tạo lịch sử tiêu dùng thành công",
    "consumptionUpdated": "Đã cập nhật lịch sử tiêu dùng thành công",
    "consumptionDeleted": "Đã xóa lịch sử tiêu dùng thành công",
    "purchaseHistory": "Lịch sử mua hàng",
    "noPurchaseHistory": "Chưa có lịch sử mua hàng",
    "enableEdit": "Chỉnh sửa",
    "cancelEdit": "Huỷ chỉnh sửa",
    "saveChanges": "Lưu thay đổi",
    "paymentStatuses": {
      "0": "Đã trả",
      "1": "Còn nợ"
    },
    "filters": {
      "fromDate": "Từ ngày",
      "toDate": "Đến ngày",
      "allEmployees": "Tất cả nhân viên",
      "allAssets": "Tất cả mặt hàng",
      "allPaymentStatuses": "Tất cả trạng thái"
    },
    "selectPaymentStatus": "Chọn trạng thái thanh toán"
  },
  "employeeAssetDashboard": {
    "title": "Thống kê tiêu dùng",
    "description": "Thống kê và phân tích dữ liệu tiêu dùng mặt hàng của nhân viên.",
    "topConsumedAssets": "Mặt hàng tiêu dùng",
    "recentConsumers": "Người tiêu dùng gần đây",
    "totalQuantity": "Tổng số lượng",
    "totalAmount": "Tổng thành tiền",
    "lastConsumption": "Lần gần nhất",
    "noRecentConsumers": "Chưa có dữ liệu tiêu dùng",
    "itemCount": "Mặt hàng",
    "periods": {
      "today": "Theo ngày",
      "thisWeek": "Theo tuần",
      "thisMonth": "Theo tháng",
      "thisYear": "Theo năm",
      "custom": "Tuỳ chỉnh"
    },
    "sortBy": "Sắp xếp theo",
    "sortOptions": {
      "quantity": "Số lượng",
      "amount": "Thành tiền"
    },
    "loading": "Đang tải dữ liệu...",
    "error": "Có lỗi xảy ra khi tải dữ liệu",
    "noData": "Không có dữ liệu trong khoảng thời gian này"
  },
  "dormitory": {
    "title": "Quản lý Ký túc xá",
    "tabs": {
      "hierarchy": "Cấu trúc",
      "positions": "Vị trí",
      "statistics": "Thống kê"
    },
    "hierarchy": {
      "title": "Cấu trúc Ký túc xá",
      "description": "Quản lý cấu trúc phân cấp của ký túc xá",
      "structure": "Cấu trúc",
      "dormitory": "Ký túc xá",
      "zone": "Khu",
      "room": "Phòng",
      "bed": "Giường",
      "position": "Vị trí",
      "add_dormitory": "Thêm ký túc xá",
      "add_first_dormitory": "Thêm ký túc xá đầu tiên",
      "no_dormitories": "Chưa có ký túc xá nào",
      "add_hierarchy": "Thêm cấu trúc",
      "edit_hierarchy": "Chỉnh sửa cấu trúc",
      "add_description": "Tạo mới Chưa đủ tử trong cấu trúc ký túc xá",
      "edit_description": "Cập nhật thông tin phần tử cấu trúc",
      "name": "Tên",
      "name_placeholder": "Nhập tên...",
      "type": "Loại cấu trúc",
      "select_type": "Chọn loại",
      "parent": "Cấp cha",
      "select_parent": "Chọn cấp cha",
      "description_label": "Mô tả",
      "description_placeholder": "Nhập mô tả...",
      "is_active": "Hoạt động",
      "confirm_delete": "Bạn có chắc chắn muốn xóa cấu trúc này không?",
      "confirm_delete_title": "Xác nhận xóa cấu trúc",
      "confirm_delete_description": "Hành động này không thể hoàn tác. Tất cả dữ liệu liên quan sẽ bị xóa vĩnh viễn.",
      "delete_button": "Xóa cấu trúc",
      "created_successfully": "Tạo cấu trúc thành công",
      "updated_successfully": "Cập nhật cấu trúc thành công",
      "deleted_successfully": "Xóa cấu trúc thành công"
    },
    "positions": {
      "title": "Quản lý Vị trí",
      "description": "Quản lý vị trí ngủ trong ký túc xá và gắn nhân viên",
      "coming_soon": "Tính năng đang được phát triển",
      "assign": "Gắn công nhân",
      "unassign": "Huỷ gắn",
      "move": "Điều chuyển",
      "available": "Trống",
      "occupied": "Đã đủ người",
      "partiallyOccupied": "Chưa đủ",
      "partiallyoccupied": "Chưa đủ",
      "maintenance": "Bảo trì",
      "reserved": "Đặt trước",
      "created_successfully": "Tạo vị trí thành công",
      "updated_successfully": "Cập nhật vị trí thành công",
      "employee_assigned_successfully": "Gắn nhân viên thành công",
      "employee_unassigned_successfully": "Huỷ gắn nhân viên thành công",
      "employee_moved_successfully": "Điều chuyển nhân viên thành công",
      "bulk_updated_successfully": "Cập nhật hàng loạt thành công",
      "generated_missing_positions": "Đã tạo {{count}} vị trí thiếu",
      "confirm_unassign": "Bạn có chắc chắn muốn hủy phân công vị trí này không?",
      "confirm_unassign_title": "Xác nhận hủy phân công",
      "confirm_unassign_description": "Nhân viên sẽ được hủy khỏi vị trí này và vị trí sẽ trở thành trống.",
      "unassign_button": "Hủy phân công",
      "confirm_delete_position": "Bạn có chắc chắn muốn xóa vị trí này không?",
      "confirm_delete_position_title": "Xác nhận xóa vị trí",
      "confirm_delete_position_description": "Hành động này không thể hoàn tác. Vị trí và tất cả dữ liệu liên quan sẽ bị xóa vĩnh viễn.",
      "delete_position_button": "Xóa vị trí"
    },
    "statistics": {
      "title": "Thống kê Ký túc xá",
      "description": "Xem thống kê và phân tích dữ liệu ký túc xá",
      "coming_soon": "Tính năng đang được phát triển",
      "total_positions": "Tổng vị trí",
      "occupied_positions": "Vị trí đã gắn",
      "available_positions": "Vị trí trống",
      "occupancy_rate": "Tỷ lệ lấp đầy"
    },
    "employee": {
      "name": "Tên",
      "gender": "Giới tính",
      "working_status": "Trạng thái",
      "work_shift": "Ca làm việc"
    }
  },
  "insuranceType": {
    "none": "Không có bảo hiểm",
    "insured": "Có bảo hiểm"
  },
  "profile": {
    "title": "Thông tin cá nhân",
    "description": "Quản lý thông tin cá nhân, ảnh đại diện và cài đặt bảo mật.",
    "profileSettings": "Cài đặt cá nhân",
    "profilePicture": "Ảnh đại diện",
    "profilePictureDescription": "Tải lên và cập nhật ảnh đại diện",
    "personalInformation": "Thông tin cá nhân",
    "personalInformationDescription": "Cập nhật thông tin cá nhân.",
    "fullName": "Họ và tên",
    "fullNamePlaceholder": "Nhập họ và tên",
    "fullNameDescription": "Đây là tên hiển thị sẽ được hiển thị cho người dùng khác.",
    "fullNameRequired": "Họ và tên phải có ít nhất 2 ký tự.",
    "fullNameMaxLength": "Họ và tên không được dài quá 100 ký tự.",
    "email": "Email",
    "dateOfBirth": "Ngày sinh",
    "dateOfBirthDescription": "Ngày sinh.",
    "dateOfBirthRequired": "Ngày sinh là bắt buộc.",
    "pickDate": "Chọn ngày",
    "uploadAvatar": "Tải lên ảnh đại diện",
    "uploading": "Đang tải lên...",
    "recommendedFormat": "Khuyến nghị: Ảnh vuông, tối đa 5MB",
    "fileSizeLimit": "Kích thước file phải nhỏ hơn 5MB",
    "selectImageFile": "Vui lòng chọn file ảnh",
    "avatarUpdated": "Đã cập nhật ảnh đại diện thành công",
    "cropAvatar": "Cắt ảnh đại diện",
    "saveAvatar": "Lưu ảnh đại diện",
    "saveChanges": "Lưu thay đổi",
    "saving": "Đang lưu...",
    "reset": "Đặt lại",
    "changePassword": "Đổi mật khẩu",
    "changePasswordDescription": "Đảm bảo mật khẩu có ít nhất 8 ký tự.",
    "currentPassword": "Mật khẩu hiện tại",
    "currentPasswordPlaceholder": "Nhập mật khẩu hiện tại",
    "currentPasswordDescription": "Nhập mật khẩu hiện tại để xác minh danh tính.",
    "currentPasswordRequired": "Mật khẩu hiện tại là bắt buộc.",
    "newPassword": "Mật khẩu mới",
    "newPasswordPlaceholder": "Nhập mật khẩu mới",
    "newPasswordDescription": "Mật khẩu mới phải có ít nhất 8 ký tự.",
    "newPasswordRequired": "Mật khẩu mới phải có ít nhất 8 ký tự.",
    "newPasswordMaxLength": "Mật khẩu mới không được vượt quá 100 ký tự.",
    "confirmPassword": "Xác nhận mật khẩu mới",
    "confirmPasswordPlaceholder": "Xác nhận mật khẩu mới",
    "confirmPasswordDescription": "Nhập lại mật khẩu mới để xác nhận.",
    "confirmPasswordRequired": "Vui lòng xác nhận mật khẩu mới.",
    "passwordMismatch": "Mật khẩu không khớp",
    "changePasswordButton": "Đổi mật khẩu",
    "changing": "Đang đổi...",
    "accessDenied": "Không có quyền truy cập",
    "accessDeniedDescription": "Bạn không có quyền xem trang này.",
    "profileUpdated": "Đã cập nhật thông tin cá nhân thành công",
    "profileUpdateFailed": "Cập nhật thông tin cá nhân thất bại",
    "avatarUpdateFailed": "Cập nhật ảnh đại diện thất bại",
    "passwordChanged": "Đổi mật khẩu thành công",
    "passwordChangeFailed": "Đổi mật khẩu thất bại"
  },
  "assetConsumption": {
    "title": "Quản lý tiêu dùng mặt hàng",
    "description": "Quản lý và theo dõi việc tiêu dùng mặt hàng của nhân viên.",
    "addConsumption": "Thêm tiêu dùng",
    "editConsumption": "Chỉnh sửa tiêu dùng",
    "viewConsumption": "Xem chi tiết tiêu dùng",
    "deleteConsumption": "Xóa tiêu dùng",
    "consumptionDate": "Ngày mua",
    "employee": "Nhân viên",
    "items": "Mặt hàng",
    "quantity": "Số lượng",
    "unitPrice": "Đơn giá",
    "totalPrice": "Thành tiền",
    "totalAmount": "Tổng tiền",
    "note": "Ghi chú",
    "export": "Xuất Excel",
    "filter": "Lọc",
    "fromDate": "Từ ngày",
    "toDate": "Đến ngày",
    "selectEmployee": "Chọn nhân viên",
    "selectAsset": "Mặt hàng",
    "allEmployees": "Tất cả nhân viên",
    "allAssets": "Tất cả mặt hàng",
    "statistics": "Thống kê",
    "topConsumedAssets": "Mặt hàng tiêu dùng nhiều nhất",
    "consumptionCount": "Số lần tiêu dùng",
    "noData": "Không có dữ liệu",
    "loading": "Đang tải...",
    "exporting": "Đang xuất...",
    "exportSuccess": "Xuất file thành công",
    "exportError": "Lỗi khi xuất file",
    "addItem": "Thêm mặt hàng",
    "removeItem": "Xóa mặt hàng",
    "selectAssetFirst": "Vui lòng chọn mặt hàng",
    "quantityRequired": "Số lượng bắt buộc",
    "quantityMin": "Số lượng phải lớn hơn 0",
    "employeeRequired": "Vui lòng chọn nhân viên",
    "itemsRequired": "Phải có ít nhất 1 mặt hàng",
    "consumptionDateRequired": "Vui lòng chọn ngày tiêu dùng",
    "createSuccess": "Tạo tiêu dùng thành công",
    "updateSuccess": "Cập nhật tiêu dùng thành công",
    "deleteSuccess": "Xóa tiêu dùng thành công",
    "createError": "Lỗi khi tạo tiêu dùng",
    "updateError": "Lỗi khi cập nhật tiêu dùng",
    "deleteError": "Lỗi khi xóa tiêu dùng",
    "deleteConfirm": "Bạn có chắc chắn muốn xóa bản ghi tiêu dùng này không?",
    "selectPaymentStatusForAll": "Vui lòng chọn trạng thái thanh toán cho tất cả mặt hàng",
    "exportExcelSuccess": "Xuất Excel thành công",
    "exportExcelError": "Lỗi khi xuất Excel"
  },
  "accountingTransactions": {
    "title": "Danh sách giao dịch thu chi",
    "description": "Quản lý và theo dõi các giao dịch kế toán của doanh nghiệp.",
    "addTransaction": "Tạo giao dịch",
    "create": "Tạo giao dịch",
    "editTransaction": "Chỉnh sửa giao dịch",
    "viewTransaction": "Xem chi tiết giao dịch",
    "deleteTransaction": "Xóa giao dịch",
    "approveTransaction": "Phê duyệt giao dịch",
    "addTransactionDescription": "Tạo giao dịch kế toán mới.",
    "editTransactionDescription": "Cập nhật thông tin giao dịch kế toán.",
    "deleteTransactionConfirm": "Bạn có chắc chắn muốn xóa giao dịch này không?",
    "approveTransactionConfirm": "Bạn có chắc chắn muốn phê duyệt giao dịch này không?",
    "seqNumber": "Số giao dịch",
    "isIncome": "Thu / Chi",
    "income": "Thu",
    "expense": "Chi",
    "isReportRevenue": "Thêm vào báo cáo",
    "isReportRevenueYes": "Có",
    "isReportRevenueNo": "Không",
    "all": "Tất cả",
    "transactionType": "Loại giao dịch",
    "transactionCategory": "Danh mục",
    "transactionTypes": {
      "Insurance": "Bảo hiểm",
      "Gift": "Quà tặng",
      "Asset": "Hàng tiêu dùng",
      "EmployeeSalary": "Lương"
    },
    "lifeStatus": "Trạng thái",
    "lifeStatuses": {
      "Draft": "Bản nháp",
      "Pending": "Chờ kiểm tra",
      "Verified": "Đã kiểm tra",
      "Approved": "Đã phê duyệt"
    },
    "amount": "Trước thuế",
    "note": "Nội dung",
    "attachments": "Tệp đính kèm",
    "referenceSource": "Nguồn tham chiếu",
    "referenceEntity": "Đối tượng tham chiếu",
    "referenceId": "ID tham chiếu",
    "referenceDisplayText": "Tên tham chiếu",
    "transactionDate": "Ngày giao dịch",
    "createdBy": "Người tạo",
    "approvedBy": "Người phê duyệt",
    "approvedAt": "Ngày phê duyệt",
    "approvalNote": "Ghi chú phê duyệt",
    "company": "Công ty",
    "createdAt": "Ngày tạo",
    "updatedAt": "Cập nhật",
    "bookNumber": "Quyển số",
    "debitAccount": "Tài khoản Nợ",
    "creditAccount": "Tài khoản Có",
    "partnerPerson": "Người nộp/nhận",
    "address": "Địa chỉ",
    "amountInWords": "Số tiền bằng chữ",
    "invoiceDetails": {
      "title": "Bảng kê chi tiết",
      "type": "Loại bảng kê",
      "types": {
        "VAT": "Hóa đơn GTGT (VAT)",
        "NonVAT": "Bảng kê mua hàng (Không VAT)"
      },
      "purchasingOrganization": "Đơn vị thu mua",
      "purchasingPerson": "Người thu mua",
      "totalGoodsValue": "Tổng giá trị hàng hóa",
      "items": "Danh sách chi tiết",
      "order": "STT",
      "date": "Ngày",
      "totalAmount": "Tổng thanh toán",
      "invoiceNumber": "Số hóa đơn",
      "invoiceSerial": "Ký hiệu",
      "partnerName": "Tên nhà cung cấp",
      "partnerTaxCode": "MST nhà cung cấp",
      "amountBeforeTax": "Tiền trước thuế",
      "taxAmount": "Tiền thuế",
      "paymentMethod": "Hình thức thanh toán",
      "partnerAddress": "Địa chỉ người bán",
      "partnerIdCard": "CCCD người bán",
      "itemName": "Tên mặt hàng",
      "unit": "ĐVT",
      "quantity": "Số lượng",
      "unitPrice": "Đơn giá",
      "addItem": "Thêm dòng",
      "removeItem": "Xóa dòng"
    },
    "selectTransactionType": "Chọn loại giao dịch",
    "selectLifeStatus": "Chọn trạng thái",
    "selectIncomeType": "Chọn loại thu chi",
    "allTransactionTypes": "Tất cả loại",
    "allLifeStatuses": "Tất cả trạng thái",
    "searchTransactions": "Tìm kiếm giao dịch...",
    "noTransactions": "Không có giao dịch nào",
    "transactionCreated": "Tạo giao dịch thành công",
    "transactionUpdated": "Cập nhật giao dịch thành công",
    "transactionDeleted": "Xóa giao dịch thành công",
    "transactionApproved": "Phê duyệt giao dịch thành công",
    "transactionCreateError": "Lỗi khi tạo giao dịch",
    "transactionUpdateError": "Lỗi khi cập nhật giao dịch",
    "transactionDeleteError": "Lỗi khi xóa giao dịch",
    "transactionApproveError": "Lỗi khi phê duyệt giao dịch",
    "deleteError": "Có lỗi xảy ra khi xóa giao dịch",
    "updateCompanyError": "Có lỗi xảy ra khi cập nhật công ty",
    "updateDateError": "Có lỗi xảy ra khi cập nhật ngày giao dịch",
    "notApproved": "Chưa duyệt",
    "status": "Trạng thái",
    "statuses": {
      "Draft": "Bản nháp",
      "Pending": "Chờ duyệt",
      "Approved": "Đã phê duyệt"
    },
    "filters": {
      "title": "Bộ lọc giao dịch",
      "fromDate": "Từ ngày",
      "toDate": "Đến ngày",
      "approvedFromDate": "Phê duyệt từ ngày",
      "approvedToDate": "Phê duyệt đến ngày",
      "minAmount": "Từ số tiền",
      "maxAmount": "Đến số tiền",
      "hasTax": "Thuế",
      "noTax": "Không thuế",
      "withTax": "Có thuế"
    },
    "validation": {
      "transactionTypeRequired": "Vui lòng chọn loại giao dịch",
      "amountRequired": "Số tiền là bắt buộc",
      "amountMin": "Số tiền phải lớn hơn 0",
      "transactionDateRequired": "Vui lòng chọn ngày giao dịch",
      "approvalNoteRequired": "Ghi chú phê duyệt là bắt buộc"
    },
    "placeholders": {
      "searchTransactions": "Số giao dịch",
      "enterAmount": "Nhập số tiền...",
      "enterNote": "Nhập ghi chú...",
      "enterApprovalNote": "Nhập ghi chú phê duyệt...",
      "enterReferenceDisplayText": "Nhập tên tham chiếu...",
      "selectDate": "Chọn ngày",
      "selectCompany": "Chọn công ty",
      "enterBookNumber": "Nhập quyển số...",
      "enterPartnerPerson": "Nhập người nộp/nhận...",
      "enterAddress": "Nhập địa chỉ...",
      "enterAmountInWords": "Số tiền bằng chữ...",
      "selectAccount": "Chọn tài khoản..."
    },
    "statistics": {
      "totalIncome": "Tổng thu",
      "totalExpense": "Tổng chi",
      "netAmount": "Số dư",
      "totalTransactions": "Tổng giao dịch",
      "approvedTransactions": "Đã phê duyệt",
      "draftTransactions": "Bản nháp"
    },
    "export": {
      "title": "Xuất báo cáo",
      "description": "Xuất danh sách giao dịch kế toán",
      "format": "Định dạng",
      "excel": "Excel",
      "csv": "CSV",
      "dateRange": "Khoảng thời gian",
      "customRange": "Tùy chỉnh",
      "success": "Xuất báo cáo thành công",
      "error": "Lỗi khi xuất báo cáo"
    },
    "taxPercent": "Thuế suất"
  },
  "employeeWalletDashboard": {
    "title": "Thống kê lương công nhân",
    "description": "Thống kê và theo dõi giao dịch lương công nhân.",
    "totalSalary": "Tổng lương/công",
    "regularAndOvertime": "HC + Tăng ca",
    "totalWithdrawn": "Đã rút",
    "netAmount": "Số dư",
    "transactions": "giao dịch",
    "employees": "công nhân",
    "regularWork": "Công hành chính",
    "overtime": "Tăng ca",
    "lackHours": "Thiếu giờ làm",
    "attendanceAllowance": "Phụ cấp chuyên cần",
    "adjustment": "Điều chỉnh",
    "increaseAdjustment": "Cộng tiền khác",
    "decreaseAdjustment": "Trừ tiền khác",
    "advancePayment": "Ứng lương",
    "monthlySalary": "Thanh toán lương tháng",
    "deduction": "Khấu trừ nợ",
    "insurance": "Bảo hiểm",
    "withholdingSalary": "Phạt giữ lương",
    "dormitoryUtility": "Điện nước KTX",
    "salaryBreakdown": "Phân bổ lương/công",
    "withdrawnBreakdown": "Phân bổ tiền đã rút",
    "byTransactionType": "Theo loại giao dịch",
    "noData": "Không có dữ liệu",
    "periods": {
      "daily": "Ngày",
      "weekly": "Tuần",
      "monthly": "Tháng",
      "yearly": "Năm",
      "custom": "Tuỳ chỉnh"
    }
  },
  "employeeWallet": {
    "title": "Lương công nhân",
    "description": "Quản lý và theo dõi lương công nhân.",
    "addTransaction": "Tạo giao dịch",
    "create": "Tạo giao dịch",
    "editTransaction": "Chỉnh sửa giao dịch",
    "viewTransaction": "Xem chi tiết giao dịch",
    "deleteTransaction": "Xóa giao dịch",
    "deleteTransactionConfirm": "Bạn có chắc chắn muốn xóa giao dịch này không?",
    "seqNumber": "Số giao dịch",
    "employee": "Công nhân",
    "selectEmployee": "Chọn công nhân",
    "searchEmployee": "Tìm kiếm công nhân...",
    "company": "Công ty",
    "transactionType": "Loại giao dịch",
    "direction": "Chiều giao dịch",
    "amount": "Số tiền",
    "balanceAfter": "Số dư sau giao dịch",
    "source": "Nguồn",
    "transactionDate": "Ngày giao dịch",
    "note": "Ghi chú",
    "createdBy": "Người tạo",
    "startDate": "Từ ngày",
    "endDate": "Đến ngày",
    "placeholders": {
      "search": "Tìm kiếm theo số giao dịch, tên công nhân...",
      "enterAmount": "Nhập số tiền...",
      "enterNote": "Nhập ghi chú...",
      "selectDate": "Chọn ngày"
    },
    "directions": {
      "CREDIT": "Cộng tiền",
      "DEBIT": "Trừ tiền"
    },
    "validation": {
      "employeeRequired": "Vui lòng chọn công nhân",
      "transactionTypeRequired": "Vui lòng chọn loại giao dịch",
      "directionRequired": "Vui lòng chọn chiều giao dịch",
      "amountRequired": "Số tiền là bắt buộc",
      "amountMin": "Số tiền phải lớn hơn 0",
      "transactionDateRequired": "Vui lòng chọn ngày giao dịch"
    },
    "transactionCreated": "Tạo giao dịch thành công",
    "transactionUpdated": "Cập nhật giao dịch thành công",
    "transactionDeleted": "Xóa giao dịch thành công",
    "transactionCreateError": "Lỗi khi tạo giao dịch",
    "transactionUpdateError": "Lỗi khi cập nhật giao dịch",
    "transactionDeleteError": "Lỗi khi xóa giao dịch",
    "onlyManualCanEdit": "Chỉ có thể chỉnh sửa giao dịch thủ công",
    "recalculateBalanceSuccess": "Tính lại số dư thành công",
    "recalculateBalanceError": "Lỗi khi tính lại số dư",
    "noDebtToDeduct": "Không có nợ tiêu dùng để khấu trừ",
    "selectAtLeastOneTransaction": "Vui lòng chọn ít nhất 1 giao dịch để xóa"
  },
  "assetManagement": {
    "title": "Quản lý mặt hàng",
    "description": "Quản lý thông tin mặt hàng tại đây.",
    "addAsset": "Thêm mặt hàng mới",
    "editAsset": "Chỉnh sửa mặt hàng",
    "addAssetDescription": "Tạo mặt hàng mới.",
    "editAssetDescription": "Cập nhật thông tin mặt hàng.",
    "name": "Tên mặt hàng",
    "assetDescription": "Mô tả",
    "price": "Giá",
    "unit": "Đơn vị",
    "units": {
      "Piece": "Cái",
      "Kilogram": "Kg",
      "Liter": "Lít",
      "Meter": "Mét",
      "Box": "Thùng",
      "Bottle": "Chai",
      "Tour": "Chuyến"
    },
    "nameRequired": "Tên mặt hàng bắt buộc nhập.",
    "namePlaceholder": "Nhập tên mặt hàng...",
    "priceRequired": "Giá bắt buộc nhập.",
    "priceMin": "Giá phải lớn hơn hoặc bằng 0.",
    "unitRequired": "Đơn vị bắt buộc chọn.",
    "deleteAsset": "Xóa mặt hàng",
    "deleteAssetConfirm": "Bạn có chắc chắn muốn xóa mặt hàng này không?",
    "searchAssets": "Tìm kiếm mặt hàng...",
    "assetDetails": "Chi tiết mặt hàng",
    "assetCreated": "Đã tạo mặt hàng thành công",
    "assetUpdated": "Đã cập nhật mặt hàng thành công",
    "assetDeleted": "Đã xóa mặt hàng thành công",
    "viewAsset": "Xem chi tiết",
    "editAssetAction": "Chỉnh sửa",
    "deleteAssetAction": "Xóa",
    "noAssets": "Không có mặt hàng nào",
    "loading": "Đang tải danh sách mặt hàng...",
    "error": "Có lỗi xảy ra khi tải danh sách mặt hàng",
    "createSuccess": "Tạo mặt hàng thành công",
    "updateSuccess": "Cập nhật mặt hàng thành công",
    "deleteSuccess": "Xóa mặt hàng thành công",
    "createError": "Có lỗi xảy ra khi tạo mặt hàng",
    "updateError": "Có lỗi xảy ra khi cập nhật mặt hàng",
    "deleteError": "Có lỗi xảy ra khi xóa mặt hàng",
    "assetName": "Tên mặt hàng",
    "assetNamePlaceholder": "Nhập tên mặt hàng...",
    "descriptionPlaceholder": "Nhập mô tả...",
    "selectUnit": "Chọn đơn vị",
    "piece": "Cái",
    "kg": "Kg",
    "liter": "Lít",
    "meter": "Mét",
    "set": "Bộ",
    "pack": "Gói",
    "tour": "Chuyến",
    "assetDetailsDescription": "Xem thông tin chi tiết về mặt hàng này.",
    "deleteAssetConfirmation": "Bạn có chắc chắn muốn xóa mặt hàng \"{{name}}\" không? Hành động này không thể hoàn tác.",
    "columns": {
      "name": "Tên mặt hàng",
      "price": "Giá",
      "unit": "Đơn vị",
      "actions": "Thao tác"
    },
    "pricePlaceholder": "Nhập giá (VND)",
    "stockManagement": {
      "stockIn": "Nhập",
      "stockHistory": "Lịch sử kho",
      "stockInTitle": "Nhập - {{name}}",
      "stockInDescription": "Nhập thêm hàng vào kho cho mặt hàng này",
      "stockHistoryTitle": "Lịch sử kho - {{name}}",
      "stockHistoryDescription": "Xem lịch sử thay đổi kho của mặt hàng này",
      "quantity": "Số lượng",
      "quantityPlaceholder": "Nhập số lượng",
      "unitPrice": "Đơn giá",
      "unitPricePlaceholder": "Nhập đơn giá",
      "note": "Ghi chú",
      "notePlaceholder": "Ghi chú về lần Nhập này",
      "currentStock": "Tồn hiện tại",
      "afterStockIn": "Sau khi nhập",
      "processing": "Đang xử lý...",
      "stockInSuccess": "Nhập thành công",
      "stockInError": "Có lỗi xảy ra khi Nhập",
      "loadingHistory": "Đang tải lịch sử...",
      "noHistory": "Chưa có lịch sử thay đổi kho",
      "openingStock": "Tồn đầu",
      "stockInQty": "Nhập",
      "stockOutQty": "Xuất",
      "closingStock": "Tồn cuối",
      "changeType": {
        "StockIn": "Nhập",
        "StockOut": "Tiêu dùng",
        "GiftOut": "Quà tặng",
        "InventoryClosing": "Chốt kỳ"
      },
      "quantityLabel": "Số lượng",
      "unitPriceLabel": "Đơn giá",
      "totalAmount": "Thành tiền",
      "stockAfter": "Tồn sau",
      "reference": "Tham chiếu",
      "referenceType": {
        "employeeAsset": "Tiêu dùng",
        "employeeGift": "Quà tặng",
        "stockIn": "Nhập",
        "inventoryClosing": "Chốt kỳ"
      },
      "createdBy": "Người tạo",
      "changeDate": "Ngày thay đổi",
      "inventoryClosing": "Chốt kỳ",
      "inventoryClosingTitle": "Chốt kỳ kho - {{name}}",
      "inventoryClosingDescription": "Chốt kỳ kho hiện tại",
      "suggestedOpeningStock": "Tồn đầu đề xuất",
      "suggestedStockDescription": "Tồn kho hiện tại được đề xuất làm tồn đầu mới",
      "overrideOpeningStock": "Tồn đầu ghi đè",
      "overrideStockPlaceholder": "Nhập giá trị ghi đè (tùy chọn)",
      "overrideStockDescription": "Nếu không nhập, sẽ sử dụng giá trị đề xuất",
      "currentOpeningStock": "Tồn đầu hiện tại",
      "newOpeningStock": "Tồn đầu mới",
      "difference": "Chênh lệch",
      "inventoryClosingNotePlaceholder": "Ghi chú về việc chốt kỳ kho",
      "performInventoryClosing": "Thực hiện chốt kỳ",
      "filterByType": "Lọc theo loại",
      "filterAll": "Tất cả",
      "items": "mục",
      "noHistoryForFilter": "Không có lịch sử cho bộ lọc này"
    }
  },
  "employeeGifts": {
    "title": "Quản lý quà tặng",
    "description": "Quản lý quà tặng cho nhân viên.",
    "addGift": "Thêm quà tặng",
    "editGift": "Chỉnh sửa quà tặng",
    "viewGift": "Xem chi tiết quà tặng",
    "deleteGift": "Xóa quà tặng",
    "addGiftDescription": "Tạo quà tặng mới cho nhân viên.",
    "editGiftDescription": "Cập nhật thông tin quà tặng.",
    "deleteGiftConfirm": "Bạn có chắc chắn muốn xóa quà tặng này không?",
    "employee": "Nhân viên",
    "giftDate": "Ngày tặng",
    "giftItems": "Danh sách quà tặng",
    "gift": "Món quà",
    "quantity": "Số lượng",
    "unitPrice": "Đơn giá",
    "totalPrice": "Thành tiền",
    "totalAmount": "Tổng tiền",
    "giftStatus": "Trạng thái",
    "occasion": "Dịp tặng",
    "note": "Ghi chú",
    "selectEmployee": "Chọn nhân viên",
    "selectGift": "Chọn món quà",
    "selectGiftStatus": "Chọn trạng thái",
    "selectOccasion": "Chọn dịp tặng",
    "addGiftItem": "Thêm món quà",
    "removeGiftItem": "Xóa món quà",
    "searchEmployees": "Tìm kiếm nhân viên...",
    "searchGifts": "Tìm kiếm món quà...",
    "noEmployeesFound": "Không tìm thấy nhân viên",
    "noGiftsFound": "Không tìm thấy món quà",
    "noGiftRecords": "Không có bản ghi quà tặng",
    "giftCreated": "Tạo quà tặng thành công",
    "giftUpdated": "Cập nhật quà tặng thành công",
    "giftDeleted": "Xóa quà tặng thành công",
    "giftCreateError": "Lỗi khi tạo quà tặng",
    "giftUpdateError": "Lỗi khi cập nhật quà tặng",
    "giftDeleteError": "Lỗi khi xóa quà tặng",
    "selectStatusForAllGifts": "Vui lòng chọn trạng thái cho tất cả món quà",
    "loadGiftInfoError": "Lỗi tải thông tin quà tặng",
    "fileAddedToGift": "{{fileName}} đã được thêm vào quà tặng",
    "fileUploadSuccess": "{{fileName}} đã tải lên thành công",
    "fileRemovedFromGift": "Tệp đính kèm đã được xóa khỏi quà tặng",
    "fileRemoved": "Tệp đính kèm đã được xóa",
    "fileUploadError": "Lỗi tải lên {{fileName}}",
    "fileDeleteError": "Lỗi xóa tệp đính kèm",
    "downloadUrlUnavailable": "URL tải xuống không khả dụng",
    "fileDownloadError": "Lỗi tải xuống tệp",
    "fileSizeLimit100MB": "{{fileName}}: Kích thước tệp phải nhỏ hơn 100MB",
    "fileTypeNotSupported": "{{fileName}}: Chỉ hỗ trợ tệp ảnh (JPG, PNG, GIF, BMP, WebP)",
    "fileUrlUnavailable": "URL tệp không khả dụng",
    "exportPerRecord": "Xuất theo từng bản ghi",
    "exportPerEmployee": "Xuất theo nhân viên",
    "exportSuccess": "Xuất Excel thành công",
    "exportError": "Lỗi khi xuất Excel",
    "filters": {
      "fromDate": "Từ ngày",
      "toDate": "Đến ngày",
      "minAmount": "Từ số tiền",
      "maxAmount": "Đến số tiền",
      "allStatuses": "Tất cả trạng thái",
      "allOccasions": "Tất cả dịp tặng"
    },
    "giftStatuses": {
      "prepared": "Đã chuẩn bị",
      "delivered": "Đã trao",
      "returned": "Đã trả lại"
    },
    "validation": {
      "employeeRequired": "Vui lòng chọn nhân viên",
      "giftDateRequired": "Vui lòng chọn ngày tặng",
      "giftItemsRequired": "Phải có ít nhất 1 món quà",
      "giftRequired": "Vui lòng chọn món quà",
      "quantityRequired": "Số lượng là bắt buộc",
      "quantityMin": "Số lượng phải lớn hơn 0",
      "unitPriceRequired": "Đơn giá là bắt buộc",
      "unitPriceMin": "Đơn giá phải lớn hơn 0"
    },
    "placeholders": {
      "searchEmployeeGifts": "Tìm kiếm theo tên, stt, cccd...",
      "enterOccasion": "Nhập dịp tặng...",
      "enterNote": "Nhập ghi chú...",
      "enterQuantity": "Nhập số lượng...",
      "enterUnitPrice": "Nhập đơn giá..."
    }
  },
  "transactionCategory": {
    "title": "Quản lý danh mục giao dịch",
    "description": "Tạo và quản lý danh mục giao dịch theo cấu trúc phân cấp",
    "createSuccess": "Tạo danh mục thành công",
    "createError": "Lỗi khi tạo danh mục",
    "updateSuccess": "Cập nhật danh mục thành công",
    "updateError": "Lỗi khi cập nhật danh mục",
    "deleteSuccess": "Xóa danh mục thành công",
    "deleteError": "Lỗi khi xóa danh mục"
  },
  "skills": {
    "title": "Quản lý kỹ năng",
    "description": "Tạo và quản lý kỹ năng công nhân theo cấu trúc phân cấp",
    "addSkill": "Thêm kỹ năng",
    "createSkill": "Tạo kỹ năng mới",
    "editSkill": "Chỉnh sửa kỹ năng",
    "deleteSkill": "Xóa kỹ năng",
    "name": "Tên kỹ năng",
    "parent": "Kỹ năng cha",
    "level": "Cấp độ",
    "colorCode": "Mã màu",
    "employeeCount": "Số công nhân",
    "isActive": "Trạng thái",
    "sortOrder": "Thứ tự",
    "active": "Hoạt động",
    "inactive": "Không hoạt động",
    "searchSkills": "Tìm kiếm kỹ năng...",
    "selectParent": "Chọn kỹ năng cha",
    "noParent": "Không có kỹ năng cha",
    "deleteConfirm": "Bạn có chắc chắn muốn xóa kỹ năng này không?",
    "deleteWarning": "Không thể xóa kỹ năng đang được sử dụng bởi nhân viên",
    "deleteSuccess": "Xóa kỹ năng thành công",
    "createSuccess": "Tạo kỹ năng thành công",
    "updateSuccess": "Cập nhật kỹ năng thành công",
    "selectSkills": "Chọn kỹ năng",
    "skillsTab": "Kỹ năng",
    "employeeSkills": "Kỹ năng của nhân viên",
    "placeholders": {
      "searchSkills": "Tìm kiếm kỹ năng...",
      "enterName": "Nhập tên kỹ năng...",
      "enterDescription": "Nhập mô tả..."
    },
    "validation": {
      "nameRequired": "Tên kỹ năng là bắt buộc",
      "nameTooLong": "Tên kỹ năng không được vượt quá 100 ký tự"
    }
  },
  "requestTicket": {
    "title": "Quản lý yêu cầu",
    "description": "Xem và xử lý các yêu cầu từ công nhân",
    "columns": {
      "seqNumber": "Mã yêu cầu",
      "employeeName": "Công nhân",
      "requestType": "Loại yêu cầu",
      "amount": "Số tiền",
      "status": "Trạng thái",
      "effectiveDate": "Ngày hiệu lực",
      "requestNote": "Ghi chú yêu cầu",
      "reviewNote": "Ghi chú xử lý",
      "processedBy": "Người xử lý"
    },
    "requestType": {
      "salaryadvance": "Ứng lương"
    },
    "status": {
      "pending": "Chờ xử lý",
      "inprocessing": "Đang xử lý",
      "processed": "Đã xử lý",
      "rejected": "Từ chối",
      "cancelled": "Đã hủy"
    },
    "actions": {
      "create": "Tạo yêu cầu",
      "createTitle": "Tạo yêu cầu mới",
      "edit": "Chỉnh sửa",
      "editTitle": "Chỉnh sửa yêu cầu",
      "view": "Xem chi tiết",
      "viewTitle": "Chi tiết yêu cầu",
      "cancel": "Hủy yêu cầu",
      "cancelTitle": "Hủy yêu cầu",
      "cancelConfirm": "Bạn có chắc chắn muốn hủy yêu cầu này không?",
      "delete": "Xóa yêu cầu",
      "deleteTitle": "Xóa yêu cầu",
      "deleteConfirm": "Bạn có chắc chắn muốn xóa yêu cầu này không?",
      "setInProcessing": "Đang xử lý",
      "setInProcessingTitle": "Chuyển trạng thái 'Đang xử lý'",
      "process": "Xử lý hoàn thành",
      "processTitle": "Xử lý hoàn thành yêu cầu",
      "reject": "Từ chối",
      "rejectTitle": "Từ chối yêu cầu"
    },
    "filters": {
      "requestType": "Loại yêu cầu",
      "processStatus": "Trạng thái"
    },
    "placeholders": {
      "search": "Tìm kiếm theo mã, tên nhân viên..."
    },
    "reviewInfo": "Thông tin xử lý",
    "processedAt": "Thời gian xử lý",
    "statusHistory": "Lịch sử thay đổi trạng thái",
    "actionType": {
      "create": "Tạo yêu cầu",
      "update": "Cập nhật",
      "cancel": "Hủy yêu cầu",
      "set_in_processing": "Chuyển đang xử lý",
      "process": "Xử lý hoàn thành",
      "reject": "Từ chối"
    },
    "createSuccess": "Tạo yêu cầu thành công",
    "createError": "Lỗi khi tạo yêu cầu",
    "updateSuccess": "Cập nhật yêu cầu thành công",
    "updateError": "Lỗi khi cập nhật yêu cầu",
    "cancelSuccess": "Hủy yêu cầu thành công",
    "cancelError": "Lỗi khi hủy yêu cầu",
    "setInProcessingSuccess": "Chuyển trạng thái \"Đang xử lý\" thành công",
    "setInProcessingError": "Lỗi khi chuyển trạng thái",
    "processSuccess": "Xử lý yêu cầu thành công",
    "processError": "Lỗi khi xử lý yêu cầu",
    "rejectSuccess": "Từ chối yêu cầu thành công",
    "rejectError": "Lỗi khi từ chối yêu cầu",
    "deleteSuccess": "Xóa yêu cầu thành công",
    "deleteError": "Lỗi khi xóa yêu cầu"
  },
  "customTags": {
    "title": "Quản lý thẻ tùy chỉnh",
    "titleDescription": "Quản lý thẻ tùy chỉnh để phân loại dữ liệu",
    "description": "Mô tả",
    "create": "Tạo thẻ mới",
    "edit": "Chỉnh sửa thẻ",
    "name": "Tên thẻ",
    "exculdeDefaultModuleFilter": "Mặc định loại khỏi bộ lọc",
    "defaultFilter": "Bộ lọc mặc định",
    "namePlaceholder": "Nhập tên thẻ...",
    "descriptionPlaceholder": "Nhập mô tả thẻ...",
    "color": "Màu sắc",
    "applyFeatures": "Áp dụng cho module",
    "sortOrder": "Thứ tự",
    "isActive": "Đang hoạt động",
    "usageCount": "Đang sử dụng: {{count}}",
    "searchPlaceholder": "Tìm kiếm thẻ...",
    "filterByModule": "Lọc theo module",
    "noTags": "Chưa có thẻ nào. Tạo thẻ mới để bắt đầu.",
    "recalculateCounts": "Tính lại số lượng sử dụng",
    "deleteConfirmTitle": "Xác nhận xóa thẻ",
    "deleteConfirmDescription": "Bạn có chắc chắn muốn xóa thẻ \"{{name}}\" không? Hành động này không thể hoàn tác.",
    "validation": {
      "selectAtLeastOneModule": "Vui lòng chọn ít nhất một module áp dụng"
    },
    "updateSuccess": "Cập nhật thẻ thành công",
    "updateError": "Lỗi khi cập nhật thẻ",
    "metadata": {
      "invoiceProvider": {
        "title": "Thông tin nhà cung cấp",
        "address": "Địa chỉ",
        "addressPlaceholder": "Nhập địa chỉ...",
        "number": "Số điện thoại",
        "numberPlaceholder": "Nhập SĐT...",
        "tax": "Mã số thuế",
        "taxPlaceholder": "Nhập mã số thuế..."
      }
    },
    "featureModules": {
      "AccountingTransaction": "Giao dịch thu chi",
      "EmployeeAsset": "Tiêu dùng mặt hàng",
      "AccountingInvoiceProvider": "Nhà cung cấp"
    }
  },
  "payslips": {
    "title": "Quản lý phiếu lương",
    "description": "Quản lý và tạo phiếu lương cho nhân viên.",
    "filters": "Bộ lọc phiếu lương",
    "placeholders": {
      "search": "Tìm kiếm theo số phiếu, tên nhân viên..."
    },
    "columns": {
      "month": "Tháng lương",
      "status": "Trạng thái",
      "company": "Công ty",
      "seqNumber": "Số phiếu",
      "employee": "Nhân viên",
      "totalIncome": "Thu nhập",
      "totalDeduction": "Khấu trừ",
      "netSalary": "Thực lĩnh",
      "companyPaid": "Đã trả",
      "remainingAmount": "Còn lại",
      "note": "Ghi chú",
      "updatedAt": "Cập nhật"
    },
    "viewModes": {
      "company": "Công ty",
      "group": "Loại GD",
      "list": "Danh sách"
    },
    "generate": "Tạo phiếu lương",
    "generateTitle": "Tạo phiếu lương",
    "month": "Tháng lương",
    "totalIncome": "Tổng thu nhập",
    "totalDeduction": "Tổng khấu trừ",
    "netSalary": "Thực lĩnh",
    "note": "Ghi chú",
    "employee": "Nhân viên",
    "seqNumber": "Số thứ tự",
    "status": {
      "label": "Trạng thái",
      "generated": "Chờ duyệt",
      "verified": "Đã duyệt",
      "paid": "Đã trả lương",
      "partialPaid": "Đã trả một phần",
      "cancelled": "Đã hủy"
    },
    "confirmDelete": "Bạn có chắc chắn muốn xóa phiếu lương này?",
    "deleteSuccess": "Xóa phiếu lương thành công",
    "deleteError": "Lỗi khi xóa phiếu lương",
    "generateSuccess": "Tạo phiếu lương thành công",
    "generateSuccessWithCount": "Đã tạo/cập nhật thành công {{count}} phiếu lương",
    "generateError": "Lỗi khi tạo phiếu lương",
    "updateStatusSuccess": "Cập nhật trạng thái thành công",
    "updateStatusError": "Lỗi khi cập nhật trạng thái",
    "bulkDeleteConfirmTitle": "Xác nhận xóa hàng loạt",
    "bulkDeleteConfirmDescription": "Bạn đang chuẩn bị xóa {{count}} phiếu lương. Luôn đảm bảo rằng các phiếu lương này chưa được thanh toán thực tế nếu bạn muốn xóa chúng. Để xác nhận, vui lòng nhập số lượng phiếu lương cần xóa.",
    "bulkDeleteSuccess": "Đã xóa thành công {{count}} phiếu lương",
    "bulkDeletePartialSuccess": "Đã xóa thành công {{success}} phiếu lương, thất bại {{failure}}",
    "bulkDeleteError": "Lỗi khi thực hiện xóa hàng loạt phiếu lương",
    "confirmationCount": "Số lượng xác nhận",
    "confirmationPlaceholder": "Nhập số lượng {{count}} để xác nhận"
  },
  "commissionPayslips": {
    "title": "Quản lý phiếu hoa hồng",
    "description": "Quản lý và tạo phiếu hoa hồng.",
    "filters": "Bộ lọc phiếu hoa hồng",
    "placeholders": {
      "search": "Tìm kiếm theo số thứ tự hoặc tên đối tượng..."
    },
    "columns": {
      "seqNumber": "Số thứ tự",
      "targetType": "Loại đối tượng",
      "targetName": "Tên đối tượng",
      "month": "Tháng",
      "status": "Trạng thái",
      "totalWorkDays": "Tổng ngày công",
      "totalSalaryAmount": "Tổng tiền lương",
      "totalCommission": "Tổng hoa hồng",
      "totalPaid": "Đã trả",
      "remainingAmount": "Còn lại",
      "note": "Ghi chú",
      "updatedAt": "Cập nhật",
      "createdBy": "Người tạo"
    },
    "targetType": "Loại đối tượng",
    "allTypes": "Tất cả",
    "group": "Nhóm",
    "company": "Công ty",
    "status": {
      "label": "Trạng thái",
      "generated": "Chờ duyệt",
      "verified": "Đã duyệt",
      "partialPaid": "Đã trả một phần",
      "paid": "Đã trả hết",
      "cancelled": "Đã hủy"
    },
    "allStatus": "Tất cả trạng thái",
    "generate": "Tạo phiếu hoa hồng",
    "generateTitle": "Tạo phiếu hoa hồng",
    "generateSuccess": "Đã tạo/cập nhật thành công {{created}} mới, {{updated}} cập nhật, {{skipped}} bỏ qua (tổng {{count}})",
    "generateError": "Lỗi khi tạo phiếu hoa hồng",
    "regenerateSuccess": "Đồng bộ phiếu lương thành công",
    "regenerateError": "Lỗi khi đồng bộ phiếu lương",

    "updateStatus": "Cập nhật trạng thái",
    "updateStatusSuccess": "Cập nhật trạng thái thành công",
    "updateStatusError": "Lỗi khi cập nhật trạng thái",
    "deleteSuccess": "Xóa bảng lương hoa hồng thành công",
    "deleteError": "Lỗi khi xóa bảng lương hoa hồng",
    "confirmDelete": "Bạn có chắc chắn muốn xóa bảng lương hoa hồng này?",
    "bulkDeleteSuccess": "Đã xóa thành công {{count}} bảng lương hoa hồng",
    "bulkDeletePartialSuccess": "Đã xóa thành công {{success}}, thất bại {{failed}}",
    "bulkDeleteError": "Lỗi khi thực hiện xóa hàng loạt",
    "batchApproveSuccess": "Đã phê duyệt thành công {{count}} bảng lương hoa hồng",
    "batchApprovePartialSuccess": "Đã phê duyệt thành công {{success}}, thất bại {{failed}}",
    "batchApproveError": "Lỗi khi thực hiện phê duyệt hàng loạt",
    "viewDetails": "Xem chi tiết",
    "workSummary": "Tổng hợp công việc",
    "workDays": "Ngày công",
    "salaryAmount": "Tiền lương",
    "commissionCalculation": "Tính toán hoa hồng",
    "appliedSetting": "Cài đặt áp dụng",
    "commissionRate": "Tỷ lệ hoa hồng",
    "percent": "Phần trăm",
    "fixed": "Cố định",
    "leaveRecords": "Danh sách chấm công",
    "leaveDate": "Ngày nghỉ",
    "employee": "Nhân viên",
    "salaryRate": "Mức lương",
    "paymentHistory": "Lịch sử thanh toán",
    "paymentDate": "Ngày thanh toán",
    "amount": "Số tiền",
    "noLeaveRecords": "Không có dữ liệu chấm công",
    "noPaymentHistory": "Chưa có thanh toán",
    "updateSuccess": "Cập nhật thành công",
    "updateError": "Lỗi khi cập nhật",
    "generateDescription": "Tạo phiếu hoa hồng hàng tháng cho các nhóm và công ty",
    "pickMonth": "Chọn tháng",
    "selectTargetType": "Chọn loại đối tượng",
    "allTargetTypes": "Tất cả (Cả nhóm và công ty)",
    "groupsOnly": "Chỉ nhóm",
    "companiesOnly": "Chỉ công ty",
    "optionalNote": "Ghi chú tùy chọn cho bảng lương",
    "generating": "Đang tạo...",
    "updateStatusTitle": "Cập nhật trạng thái",
    "updateStatusDescription": "Cập nhật trạng thái của bảng lương hoa hồng",
    "selectStatus": "Chọn trạng thái",
    "paymentAmount": "Số tiền thanh toán",
    "enterPaymentAmount": "Nhập số tiền thanh toán",
    "optionalNoteStatus": "Ghi chú tùy chọn",
    "updating": "Đang cập nhật...",
    "requiredField": "Bắt buộc",
    "targetSelection": "Chọn đối tượng",
    "selectGroup": "Chọn nhóm",
    "selectCompany": "Chọn công ty",
    "searchGroup": "Tìm kiếm nhóm...",
    "searchCompany": "Tìm kiếm công ty...",
    "newStatus": "Trạng thái mới",
    "maxPayment": "Số tiền tối đa"
  },
  "validation": {
    "required": "Trường này là bắt buộc"
  },
  "laborContract": {
    "createSuccess": "Tạo hợp đồng thành công",
    "createError": "Có lỗi xảy ra khi tạo hợp đồng"
  },
};

// Initialize i18next
const i18n = i18next.createInstance();

i18n.init({
  lng: 'vi',
  fallbackLng: 'vi',
  resources: {
    vi: {
      translation: viTranslations
    }
  },
  interpolation: {
    escapeValue: false
  }
});

// Simple translation function that doesn't rely on React hooks
export function t(key: string, options?: any): string {
  // Extract the last part of the key as fallback (e.g., "users.title" -> "title")
  const fallback = key.split('.').pop() || key;
  // Cast the result to string to handle i18next's return type
  const translated = i18n.t(key, options);
  return typeof translated === 'string' ? translated : fallback;
}

// Helper function to create a namespaced translation function
export function tWithNamespace(namespace: string) {
  return (key: string, options?: any): string => {
    return t(`${namespace}.${key}`, options);
  };
}

export default i18n; 